/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * To change the format of this file, modify `createIconDocsNew` in icon-build-process/src/create-icon-docs.tsx.
 *
 * @codegen <<SignedSource::89369dad254e55137adbee199ee40d7d>>
 * @codegenCommand yarn build:icon-glyphs
 */
interface metadata {
	/**
	 * Default component name for the icon
	 */
	componentName: string;

	/**
	 * Package path to the icon component
	 */
	package: string;

	/**
	 * The category of the icon:
	 * - 'single-purpose' icons should only be used for the purposes listed in the 'usage' field
	 * - 'multi-purpose' icons are designed for various use cases and don't have the same usage restrictions
	 */
	categorization: 'single-purpose' | 'multi-purpose';

	/**
	 * Usage guidelines for the icon. For single-purpose icons,
	 */
	usage?: string;

	/**
	 * Additional keywords used to assist in search/lookup of an icon
	 */
	keywords: string[];

	/**
	 * The name of the team owning the icon
	 */
	team: string;

	/**
	 * The status of the icon
	 */
	status?: 'draft' | 'ready-to-publish' | 'published' | 'modified' | 'deprecated';

	/**
	 * Contact slack channel for the team owning the icon
	 */
	slackChannel?: string;

	/**
	 * A replacement icon if this icon has been deprecated
	 */
	replacement?: {
		name: string;
		location: '@atlaskit/icon' | '@atlaskit/icon-lab' | '@atlassian/icon-private';
	};

	/**
	 * Whether the icon should be recommended as a small icon
	 */
	shouldRecommendSmallIcon?: boolean;
}

const metadata: Record<string, metadata> = {
	accessibility: {
		keywords: ['accessibility', 'icon', 'a11y', 'accessibility', 'WCAG'],
		componentName: 'AccessibilityIcon',
		package: '@atlaskit/icon/core/accessibility',
		categorization: 'single-purpose',
		usage:
			'Reserved for representing accessibility and accessibility-related features and settings',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	add: {
		keywords: ['add', 'plus', 'create', 'new', 'icon', 'create', 'plus', 'jira status'],
		componentName: 'AddIcon',
		package: '@atlaskit/icon/core/add',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for creating and adding an object.',
		team: 'Design System Team',
		status: 'published',
	},
	'ai-agent': {
		keywords: ['ai-agent', 'aiagent', 'icon', 'Rovo', 'AI', 'chat agent', 'ai'],
		componentName: 'AiAgentIcon',
		package: '@atlaskit/icon/core/ai-agent',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for Rovo Agent.',
		team: 'Design System Team',
		status: 'published',
	},
	'ai-chat': {
		keywords: ['ai-chat', 'aichat', 'icon', 'Rovo', 'AI', 'chat agent', 'white label'],
		componentName: 'AiChatIcon',
		package: '@atlaskit/icon/core/ai-chat',
		categorization: 'single-purpose',
		usage: 'Reserved for white label Rovo experiences.',
		team: 'Central AI',
		status: 'published',
	},
	'ai-generative-text-summary': {
		keywords: [
			'ai-generative-text-summary',
			'aigenerativetextsummary',
			'icon',
			'summarize',
			'summarise',
			'summary',
			'automation',
			'AI',
		],
		componentName: 'AiGenerativeTextSummaryIcon',
		package: '@atlaskit/icon/core/ai-generative-text-summary',
		categorization: 'single-purpose',
		usage: 'Reserved for summarizing content with Atlassian Intelligence & Loom',
		team: 'Atlassian Intelligence & Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'ai-sparkle': {
		keywords: [
			'ai-sparkle',
			'aisparkle',
			'icon',
			'AI',
			'sparkles',
			'generative AI',
			'AI functionality',
		],
		componentName: 'AiSparkleIcon',
		package: '@atlaskit/icon/core/ai-sparkle',
		categorization: 'single-purpose',
		usage:
			"Reserved for representing AI-powered features and functionality.  Note: The 'Editions' gem icon has replaced the sparkle icon for representing premium features in upsell experiences.",
		team: 'Design System Team',
		status: 'published',
	},
	alert: {
		keywords: ['alert', 'icon', 'alert', 'event', 'operations'],
		componentName: 'AlertIcon',
		package: '@atlaskit/icon/core/alert',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for alerts in JSM and Compass.',
		team: 'Design System Team',
		status: 'published',
	},
	'align-image-center': {
		keywords: [
			'align-image-center',
			'alignimagecenter',
			'icon',
			'content',
			'media',
			'image',
			'alignment',
			'centre',
		],
		componentName: 'AlignImageCenterIcon',
		package: '@atlaskit/icon/core/align-image-center',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for center aligning media and content.',
		team: 'Design System Team',
		status: 'published',
	},
	'align-image-left': {
		keywords: [
			'align-image-left',
			'alignimageleft',
			'icon',
			'content',
			'media',
			'image',
			'alignment',
			'left',
		],
		componentName: 'AlignImageLeftIcon',
		package: '@atlaskit/icon/core/align-image-left',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for left aligning media and content.',
		team: 'Design System Team',
		status: 'published',
	},
	'align-image-right': {
		keywords: [
			'align-image-right',
			'alignimageright',
			'icon',
			'content',
			'media',
			'image',
			'alignment',
			'right',
		],
		componentName: 'AlignImageRightIcon',
		package: '@atlaskit/icon/core/align-image-right',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for right aligning media and content.',
		team: 'Design System Team',
		status: 'published',
	},
	'align-text-center': {
		keywords: ['align-text-center', 'aligntextcenter', 'icon', 'alignment', 'text', 'content'],
		componentName: 'AlignTextCenterIcon',
		package: '@atlaskit/icon/core/align-text-center',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: align text center, align center.',
		team: 'Design System Team',
		status: 'published',
	},
	'align-text-left': {
		keywords: [
			'align-text-left',
			'aligntextleft',
			'icon',
			'alignment',
			'text',
			'content',
			'summary',
		],
		componentName: 'AlignTextLeftIcon',
		package: '@atlaskit/icon/core/align-text-left',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: align text left, align content left, summary.',
		team: 'Design System Team',
		status: 'published',
	},
	'align-text-right': {
		keywords: ['align-text-right', 'aligntextright', 'icon', 'alignment', 'text', 'content'],
		componentName: 'AlignTextRightIcon',
		package: '@atlaskit/icon/core/align-text-right',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: align text right, align content right.',
		team: 'Design System Team',
		status: 'published',
	},
	'angle-brackets': {
		keywords: [
			'angle-brackets',
			'anglebrackets',
			'icon',
			'code',
			'<>',
			'</>',
			'syntax',
			'jira status',
		],
		componentName: 'AngleBracketsIcon',
		package: '@atlaskit/icon/core/angle-brackets',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: code or source code in Bitbucket and Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	api: {
		keywords: ['api', 'icon', 'application programming interface', 'api', 'operations'],
		componentName: 'ApiIcon',
		package: '@atlaskit/icon/core/api',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Application Programming Interfaces (APIs).',
		team: 'Enterprise Operations Center',
		status: 'published',
	},
	app: {
		keywords: ['app', 'icon', 'plugin', 'external app', 'third-party app', 'add-on', 'add on'],
		componentName: 'AppIcon',
		package: '@atlaskit/icon/core/app',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for marketplace apps and integrations across apps.',
		team: 'Design System Team',
		status: 'published',
	},
	'app-switcher': {
		keywords: [
			'app-switcher',
			'appswitcher',
			'icon',
			'application switcher',
			'change app',
			'switch app',
			'app switcher',
		],
		componentName: 'AppSwitcherIcon',
		package: '@atlaskit/icon/core/app-switcher',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for app switcher in global app navigation.',
		team: 'Design System Team',
		status: 'published',
	},
	'app-switcher-legacy': {
		keywords: [
			'app-switcher-legacy',
			'appswitcherlegacy',
			'icon',
			'application switcher',
			'change app',
			'switch app',
			'app switcher',
		],
		componentName: 'AppSwitcherLegacyIcon',
		package: '@atlaskit/icon/core/app-switcher-legacy',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for the legacy app switcher in global app navigation.',
		team: 'Design System Team',
		status: 'published',
	},
	apps: {
		keywords: ['apps', 'icon', 'third-party', 'applications'],
		componentName: 'AppsIcon',
		package: '@atlaskit/icon/core/apps',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for adding or viewing apps.',
		team: 'Design System Team',
		status: 'published',
	},
	'archive-box': {
		keywords: ['archive-box', 'archivebox', 'icon', 'file box'],
		componentName: 'ArchiveBoxIcon',
		package: '@atlaskit/icon/core/archive-box',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: archiving pages, storage.',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-down': {
		keywords: ['arrow-down', 'arrowdown', 'icon', 'down', 'bottom', 'sorting'],
		componentName: 'ArrowDownIcon',
		package: '@atlaskit/icon/core/arrow-down',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Know uses: sorting table headers or Bitbucket code difference.',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-down-left': {
		keywords: [
			'arrow-down-left',
			'arrowdownleft',
			'icon',
			'diagonal arrow',
			'down',
			'left',
			'south west',
		],
		componentName: 'ArrowDownLeftIcon',
		package: '@atlaskit/icon/core/arrow-down-left',
		categorization: 'multi-purpose',
		usage: 'Known uses: Adding content from Rovo Chat into Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-down-right': {
		keywords: [
			'arrow-down-right',
			'arrowdownright',
			'icon',
			'diagonal arrow',
			'down',
			'right',
			'south east',
		],
		componentName: 'ArrowDownRightIcon',
		package: '@atlaskit/icon/core/arrow-down-right',
		categorization: 'multi-purpose',
		usage: 'Known uses: TBC',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-left': {
		keywords: ['arrow-left', 'arrowleft', 'back', 'previous', 'icon', 'back', 'previous'],
		componentName: 'ArrowLeftIcon',
		package: '@atlaskit/icon/core/arrow-left',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: back to previous screen, previous slide.',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-right': {
		keywords: ['arrow-right', 'arrowright', 'forward', 'next', 'icon', 'forward', 'next', 'link'],
		componentName: 'ArrowRightIcon',
		package: '@atlaskit/icon/core/arrow-right',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-up': {
		keywords: ['arrow-up', 'arrowup', 'icon', 'improvement', 'jira status'],
		componentName: 'ArrowUpIcon',
		package: '@atlaskit/icon/core/arrow-up',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: back to top.',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-up-left': {
		keywords: [
			'arrow-up-left',
			'arrowupleft',
			'icon',
			'diagonal arrow',
			'up',
			'right',
			'north east',
		],
		componentName: 'ArrowUpLeftIcon',
		package: '@atlaskit/icon/core/arrow-up-left',
		categorization: 'multi-purpose',
		usage: 'Known uses: TBC',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-up-right': {
		keywords: ['arrow-up-right', 'arrowupright', 'icon', 'open', 'diagonal arrow'],
		componentName: 'ArrowUpRightIcon',
		package: '@atlaskit/icon/core/arrow-up-right',
		categorization: 'multi-purpose',
		usage: 'Multi purpose',
		team: 'Design System Team',
		status: 'published',
	},
	assets: {
		keywords: ['assets', 'icon', 'assets', 'CMDB', 'configuration management database'],
		componentName: 'AssetsIcon',
		package: '@atlaskit/icon/core/assets',
		categorization: 'single-purpose',
		usage: 'Reserved for JSM Assets.',
		team: 'Assets',
		status: 'published',
	},
	'atlassian-intelligence': {
		keywords: ['atlassian-intelligence', 'atlassianintelligence', 'icon', 'AI'],
		componentName: 'AtlassianIntelligenceIcon',
		package: '@atlaskit/icon/core/atlassian-intelligence',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for Atlassian Intelligence apps or experiences.',
		team: 'Design System Team',
		status: 'published',
	},
	attachment: {
		keywords: ['attachment', 'paperclip', 'icon', 'paperclip', 'attach', 'attachment'],
		componentName: 'AttachmentIcon',
		package: '@atlaskit/icon/core/attachment',
		categorization: 'single-purpose',
		usage: 'Reserved for attaching files to work types or other objects.',
		team: 'Design System Team',
		status: 'published',
	},
	audio: {
		keywords: ['audio', 'music', 'note', 'sound', 'icon', 'music', 'musical note'],
		componentName: 'AudioIcon',
		package: '@atlaskit/icon/core/audio',
		categorization: 'single-purpose',
		usage: '📦 @atlaskit/icon/core/audio',
		team: 'Design System Team',
		status: 'published',
	},
	automation: {
		keywords: ['automation', 'icon', 'lightningbolt', 'automation rule'],
		componentName: 'AutomationIcon',
		package: '@atlaskit/icon/core/automation',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved to represent an Automation.',
		team: 'Design System Team',
		status: 'published',
	},
	backlog: {
		keywords: ['backlog', 'icon', 'rows'],
		componentName: 'BacklogIcon',
		package: '@atlaskit/icon/core/backlog',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for backlogs in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	basketball: {
		keywords: ['basketball', 'icon', 'ball', 'sports', 'basketball'],
		componentName: 'BasketballIcon',
		package: '@atlaskit/icon/core/basketball',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known usages: Sport emoji category.',
		team: 'Design System Team',
		status: 'published',
	},
	board: {
		keywords: ['board', 'icon', 'columns', 'active sprint'],
		componentName: 'BoardIcon',
		package: '@atlaskit/icon/core/board',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for boards in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	boards: {
		keywords: ['boards', 'icon'],
		componentName: 'BoardsIcon',
		package: '@atlaskit/icon/core/boards',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved as the icon to represent multiple boards.',
		team: 'Design System Team',
		status: 'published',
	},
	'book-with-bookmark': {
		keywords: ['book-with-bookmark', 'bookwithbookmark', 'icon', 'knowledge base', 'article'],
		componentName: 'BookWithBookmarkIcon',
		package: '@atlaskit/icon/core/book-with-bookmark',
		categorization: 'multi-purpose',
		usage:
			'Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.',
		team: 'Design System Team',
		status: 'published',
	},
	border: {
		keywords: [
			'border',
			'icon',
			'border',
			'image border',
			'content border',
			'editor',
			'confluence',
		],
		componentName: 'BorderIcon',
		package: '@atlaskit/icon/core/border',
		categorization: 'single-purpose',
		usage: 'Reserved for toggling the visibility of a border on an object.',
		team: 'Editor',
		status: 'published',
	},
	branch: {
		keywords: ['branch', 'icon', 'git branch', 'bitbucket branch', 'branches', 'jira status'],
		componentName: 'BranchIcon',
		package: '@atlaskit/icon/core/branch',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for branches in Bitbucket and Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	briefcase: {
		keywords: ['briefcase', 'icon', 'suitcase', 'toolbox', 'operations', 'business'],
		componentName: 'BriefcaseIcon',
		package: '@atlaskit/icon/core/briefcase',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: Job title in Atlas, Operations in JSM.',
		team: 'Design System Team',
		status: 'published',
	},
	bug: {
		keywords: ['bug', 'icon', 'bug report', 'test'],
		componentName: 'BugIcon',
		package: '@atlaskit/icon/core/bug',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: Request types in JSM, bugs in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	calendar: {
		keywords: ['calendar', 'date', 'icon', 'date', 'month', 'day', 'year', 'jira status'],
		componentName: 'CalendarIcon',
		package: '@atlaskit/icon/core/calendar',
		categorization: 'multi-purpose',
		usage:
			'Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.',
		team: 'Design System Team',
		status: 'published',
	},
	'calendar-plus': {
		keywords: ['calendar-plus', 'calendarplus', 'icon', 'calendar', 'add', 'plus', 'schedule'],
		componentName: 'CalendarPlusIcon',
		package: '@atlaskit/icon/core/calendar-plus',
		categorization: 'multi-purpose',
		usage: 'Known uses: Auto-scheduling in Jira Plans. Scheduled dates.',
		team: 'Design System Team',
		status: 'published',
	},
	camera: {
		keywords: ['camera', 'photo', 'icon'],
		componentName: 'CameraIcon',
		package: '@atlaskit/icon/core/camera',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: upload photo in Trello, photos.',
		team: 'Design System Team',
		status: 'published',
	},
	capture: {
		keywords: ['capture', 'icon', 'focus', 'focus area', 'capture'],
		componentName: 'CaptureIcon',
		package: '@atlaskit/icon/core/capture',
		replacement: { name: 'focus-area', location: '@atlaskit/icon' },
		categorization: 'single-purpose',
		usage: 'Reserved for representing Focus Areas.',
		team: 'Design System Team',
		status: 'deprecated',
	},
	card: {
		keywords: ['card', 'icon', 'card'],
		componentName: 'CardIcon',
		package: '@atlaskit/icon/core/card',
		categorization: 'multi-purpose',
		usage: 'Known uses: Representing cards in Trello. Toggling card detail in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	cash: {
		keywords: ['cash', 'icon', 'currency', 'money', 'cash', 'dollar', 'bill', 'work type'],
		componentName: 'CashIcon',
		package: '@atlaskit/icon/core/cash',
		categorization: 'multi-purpose',
		usage: "Known usages: \'Sales\' work type.",
		team: 'Design System Team',
		status: 'published',
	},
	changes: {
		keywords: ['changes', 'icon', 'jira status', 'horizontal arrows'],
		componentName: 'ChangesIcon',
		package: '@atlaskit/icon/core/changes',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for changes in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	'chart-bar': {
		keywords: [
			'chart-bar',
			'chartbar',
			'icon',
			'graph',
			'bar',
			'analytics',
			'report',
			'column chart',
		],
		componentName: 'ChartBarIcon',
		package: '@atlaskit/icon/core/chart-bar',
		categorization: 'multi-purpose',
		usage: 'Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence',
		team: 'Design System Team',
		status: 'published',
	},
	'chart-bubble': {
		keywords: ['chart-bubble', 'chartbubble', 'icon', 'graph', 'matrix', 'bubble', 'plot'],
		componentName: 'ChartBubbleIcon',
		package: '@atlaskit/icon/core/chart-bubble',
		categorization: 'multi-purpose',
		usage: 'Known uses: Bubble and matrix charts; Matrix view in in JPD',
		team: 'Design System Team',
		status: 'published',
	},
	'chart-matrix': {
		keywords: ['chart-matrix', 'chartmatrix', 'icon', 'dot chart', 'graph', 'matrix', ''],
		componentName: 'ChartMatrixIcon',
		package: '@atlaskit/icon/core/chart-matrix',
		replacement: { name: 'chart-bubble', location: '@atlaskit/icon' },
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: Matrix view in in JPD, and other matrix charts.',
		team: 'Design System Team',
		status: 'deprecated',
	},
	'chart-pie': {
		keywords: ['chart-pie', 'chartpie', 'icon', 'segment', 'chart', 'graph', 'pie'],
		componentName: 'ChartPieIcon',
		package: '@atlaskit/icon/core/chart-pie',
		categorization: 'multi-purpose',
		usage: 'Known uses: Pie and segment charts',
		team: 'Design System Team',
		status: 'published',
	},
	'chart-trend': {
		keywords: ['chart-trend', 'charttrend', 'icon', 'reports', 'graph', 'impact effort', ''],
		componentName: 'ChartTrendIcon',
		package: '@atlaskit/icon/core/chart-trend',
		replacement: { name: 'chart-trend-up', location: '@atlaskit/icon' },
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: charts, reports in Jira, and sprint insights.',
		team: 'Design System Team',
		status: 'deprecated',
	},
	'chart-trend-down': {
		keywords: [
			'chart-trend-down',
			'charttrenddown',
			'icon',
			'reports',
			'graph',
			'impact',
			'effort',
			'downward trend',
		],
		componentName: 'ChartTrendDownIcon',
		package: '@atlaskit/icon/core/chart-trend-down',
		categorization: 'multi-purpose',
		usage: 'Known uses: Downward trending data; Trend charts',
		team: 'Design System Team',
		status: 'published',
	},
	'chart-trend-up': {
		keywords: [
			'chart-trend-up',
			'charttrendup',
			'icon',
			'reports',
			'graph',
			'impact',
			'effort',
			'upward trend',
		],
		componentName: 'ChartTrendUpIcon',
		package: '@atlaskit/icon/core/chart-trend-up',
		categorization: 'multi-purpose',
		usage: 'Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.',
		team: 'Design System Team',
		status: 'published',
	},
	'chat-widget': {
		keywords: [
			'chat-widget',
			'chatwidget',
			'icon',
			'chat',
			'widget',
			'virtual service agent',
			'vsa',
		],
		componentName: 'ChatWidgetIcon',
		package: '@atlaskit/icon/core/chat-widget',
		categorization: 'single-purpose',
		usage: 'Reserved for representing a chat widget triggered by a floating action button.',
		team: 'JSM',
		status: 'published',
	},
	'check-circle': {
		keywords: ['check-circle', 'checkcircle', 'tick', 'icon', 'tick', 'yes', 'completed'],
		componentName: 'CheckCircleIcon',
		package: '@atlaskit/icon/core/check-circle',
		categorization: 'multi-purpose',
		usage:
			'Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.',
		team: 'Design System Team',
		status: 'published',
	},
	'check-circle-unchecked': {
		keywords: ['check-circle-unchecked', 'checkcircleunchecked', 'icon', 'incomplete', 'unchecked'],
		componentName: 'CheckCircleUncheckedIcon',
		package: '@atlaskit/icon/core/check-circle-unchecked',
		categorization: 'multi-purpose',
		usage: 'Known uses: Incomplete items',
		team: 'Design System Team',
		status: 'published',
	},
	'check-mark': {
		keywords: ['check-mark', 'checkmark', 'icon', 'tick'],
		componentName: 'CheckMarkIcon',
		package: '@atlaskit/icon/core/check-mark',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: table cells, checkboxes.',
		team: 'Design System Team',
		status: 'published',
	},
	'checkbox-checked': {
		keywords: ['checkbox-checked', 'checkboxchecked', 'icon', 'filled', 'checked', 'select all'],
		componentName: 'CheckboxCheckedIcon',
		package: '@atlaskit/icon/core/checkbox-checked',
		categorization: 'multi-purpose',
		usage:
			'Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.',
		team: 'Design System Team',
		status: 'published',
	},
	'checkbox-indeterminate': {
		keywords: ['checkbox-indeterminate', 'checkboxindeterminate', 'icon', 'filled', 'mixed'],
		componentName: 'CheckboxIndeterminateIcon',
		package: '@atlaskit/icon/core/checkbox-indeterminate',
		categorization: 'multi-purpose',
		usage:
			'Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.',
		team: 'Design System Team',
		status: 'published',
	},
	'checkbox-unchecked': {
		keywords: ['checkbox-unchecked', 'checkboxunchecked', 'icon', 'unchecked'],
		componentName: 'CheckboxUncheckedIcon',
		package: '@atlaskit/icon/core/checkbox-unchecked',
		categorization: 'multi-purpose',
		usage:
			'Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.',
		team: 'Design System Team',
		status: 'published',
	},
	'chevron-double-left': {
		keywords: [
			'chevron-double-left',
			'chevrondoubleleft',
			'icon',
			'double chevron',
			'previous year',
			'left',
		],
		componentName: 'ChevronDoubleLeftIcon',
		package: '@atlaskit/icon/core/chevron-double-left',
		shouldRecommendSmallIcon: true,
		categorization: 'multi-purpose',
		usage: 'Known uses: Navigate to previous year in calendar/date picker',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'chevron-double-right': {
		keywords: [
			'chevron-double-right',
			'chevrondoubleright',
			'icon',
			'double chevron',
			'right',
			'next year',
		],
		componentName: 'ChevronDoubleRightIcon',
		package: '@atlaskit/icon/core/chevron-double-right',
		shouldRecommendSmallIcon: true,
		categorization: 'multi-purpose',
		usage: 'Known uses: Navigate to next year in calendar/date picker',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'chevron-down': {
		keywords: [
			'chevron-down',
			'chevrondown',
			'expand',
			'collapse',
			'icon',
			'chevron down',
			'expand',
			'open',
		],
		componentName: 'ChevronDownIcon',
		package: '@atlaskit/icon/core/chevron-down',
		shouldRecommendSmallIcon: true,
		categorization: 'multi-purpose',
		usage:
			'Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons. Known uses: Open dropdown menu, expanded tree item, collapse tree item',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'chevron-left': {
		keywords: [
			'chevron-left',
			'chevronleft',
			'back',
			'previous',
			'icon',
			'chevron left',
			'back',
			'previous',
		],
		componentName: 'ChevronLeftIcon',
		package: '@atlaskit/icon/core/chevron-left',
		shouldRecommendSmallIcon: true,
		categorization: 'multi-purpose',
		usage:
			'Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons. Known uses: Navigate back, show previous page of pagination results',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'chevron-right': {
		keywords: [
			'chevron-right',
			'chevronright',
			'forward',
			'next',
			'icon',
			'chevron right',
			'next',
			'collapsed',
			'expand',
			'show children',
		],
		componentName: 'ChevronRightIcon',
		package: '@atlaskit/icon/core/chevron-right',
		shouldRecommendSmallIcon: true,
		categorization: 'multi-purpose',
		usage:
			'Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons. Known uses: Next page of pagination results, collapsed tree item, expand tree item',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'chevron-up': {
		keywords: [
			'chevron-up',
			'chevronup',
			'expand',
			'collapse',
			'icon',
			'chevron up',
			'close dropdown menu',
			'collapse',
		],
		componentName: 'ChevronUpIcon',
		package: '@atlaskit/icon/core/chevron-up',
		shouldRecommendSmallIcon: true,
		categorization: 'multi-purpose',
		usage:
			'Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons. Known uses: Close dropdown menu',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'child-work-items': {
		keywords: [
			'child-work-items',
			'childworkitems',
			'icon',
			'children',
			'child',
			'related',
			'work items',
		],
		componentName: 'ChildWorkItemsIcon',
		package: '@atlaskit/icon/core/child-work-items',
		categorization: 'single-purpose',
		usage: 'Reserved for child work items.',
		team: 'Design System Team',
		status: 'published',
	},
	clipboard: {
		keywords: ['clipboard', 'icon', 'clipboard', 'paste'],
		componentName: 'ClipboardIcon',
		package: '@atlaskit/icon/core/clipboard',
		categorization: 'multi-purpose',
		usage: 'Known uses: Pasting content from clipboard.',
		team: 'Design System Team',
		status: 'published',
	},
	clock: {
		keywords: ['clock', 'icon', 'time', 'recent', 'history'],
		componentName: 'ClockIcon',
		package: '@atlaskit/icon/core/clock',
		categorization: 'multi-purpose',
		usage: 'Known uses: recent, time input, sprint time remaining, overdue task work type status.',
		team: 'Design System Team',
		status: 'published',
	},
	close: {
		keywords: ['close', 'icon', 'cross', 'x', 'close', 'remove'],
		componentName: 'CloseIcon',
		package: '@atlaskit/icon/core/close',
		replacement: { name: 'cross', location: '@atlaskit/icon' },
		categorization: 'multi-purpose',
		usage: 'Known uses: closing modals, panels, and transient views; removing tags',
		team: 'Design System Team',
		status: 'deprecated',
	},
	'cloud-arrow-up': {
		keywords: ['cloud-arrow-up', 'cloudarrowup', 'icon', 'deployments', 'up arrow'],
		componentName: 'CloudArrowUpIcon',
		package: '@atlaskit/icon/core/cloud-arrow-up',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: deployments in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	'collapse-horizontal': {
		keywords: [
			'collapse-horizontal',
			'collapsehorizontal',
			'icon',
			'collapse',
			'width',
			'horizontal arrows',
		],
		componentName: 'CollapseHorizontalIcon',
		package: '@atlaskit/icon/core/collapse-horizontal',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for contracting or reducing the width of an element to its smallest size.',
		team: 'Design System Team',
		status: 'published',
	},
	'collapse-vertical': {
		keywords: [
			'collapse-vertical',
			'collapsevertical',
			'icon',
			'collapse',
			'height',
			'vertical arrows',
		],
		componentName: 'CollapseVerticalIcon',
		package: '@atlaskit/icon/core/collapse-vertical',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for contracting or reducing the height of an element to its smallest size.',
		team: 'Design System Team',
		status: 'published',
	},
	comment: {
		keywords: ['comment', 'chat', 'speech', 'icon', 'speech bubble'],
		componentName: 'CommentIcon',
		package: '@atlaskit/icon/core/comment',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for comments on objects.',
		team: 'Design System Team',
		status: 'published',
	},
	'comment-add': {
		keywords: ['comment-add', 'commentadd', 'icon', 'speech bubble', 'plus'],
		componentName: 'CommentAddIcon',
		package: '@atlaskit/icon/core/comment-add',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for adding a comment to an object.',
		team: 'Design System Team',
		status: 'published',
	},
	commit: {
		keywords: ['commit', 'icon', 'git commit', 'bitbucket commit'],
		componentName: 'CommitIcon',
		package: '@atlaskit/icon/core/commit',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for commits in Jira or Bitbucket.',
		team: 'Design System Team',
		status: 'published',
	},
	compass: {
		keywords: ['compass', 'icon', 'template'],
		componentName: 'CompassIcon',
		package: '@atlaskit/icon/core/compass',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: templates.',
		team: 'Design System Team',
		status: 'published',
	},
	component: {
		keywords: ['component', 'block', 'lego', 'icon', 'lego', 'brick', 'block'],
		componentName: 'ComponentIcon',
		package: '@atlaskit/icon/core/component',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for components in Jira and Compass.',
		team: 'Design System Team',
		status: 'published',
	},
	'content-width-narrow': {
		keywords: [
			'content-width-narrow',
			'contentwidthnarrow',
			'icon',
			'content',
			'media',
			'image',
			'width',
			'fixed',
			'narrow',
		],
		componentName: 'ContentWidthNarrowIcon',
		package: '@atlaskit/icon/core/content-width-narrow',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for setting media and content to a narrow width.',
		team: 'Design System Team',
		status: 'published',
	},
	'content-width-wide': {
		keywords: [
			'content-width-wide',
			'contentwidthwide',
			'icon',
			'content',
			'media',
			'image',
			'width',
			'fixed',
			'wide',
		],
		componentName: 'ContentWidthWideIcon',
		package: '@atlaskit/icon/core/content-width-wide',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for setting media and content to a wide width.',
		team: 'Design System Team',
		status: 'published',
	},
	'content-wrap-left': {
		keywords: [
			'content-wrap-left',
			'contentwrapleft',
			'icon',
			'content',
			'media',
			'image',
			'alignment',
			'left',
			'inline',
			'wrap',
		],
		componentName: 'ContentWrapLeftIcon',
		package: '@atlaskit/icon/core/content-wrap-left',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for left aligning media and content with wrapping enabled.',
		team: 'Design System Team',
		status: 'published',
	},
	'content-wrap-right': {
		keywords: [
			'content-wrap-right',
			'contentwrapright',
			'icon',
			'content',
			'media',
			'image',
			'alignment',
			'right',
			'inline',
			'wrap',
		],
		componentName: 'ContentWrapRightIcon',
		package: '@atlaskit/icon/core/content-wrap-right',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for right aligning media and content with wrapping enabled.',
		team: 'Design System Team',
		status: 'published',
	},
	copy: {
		keywords: ['copy', 'duplicate', 'icon', 'copy', 'object'],
		componentName: 'CopyIcon',
		package: '@atlaskit/icon/core/copy',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for copying data such as text, code or other objects.',
		team: 'Design System Team',
		status: 'published',
	},
	'credit-card': {
		keywords: ['credit-card', 'creditcard', 'icon', 'payment', 'invoice'],
		componentName: 'CreditCardIcon',
		package: '@atlaskit/icon/core/credit-card',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.',
		team: 'Design System Team',
		status: 'published',
	},
	cross: {
		keywords: ['cross', 'close', 'x', 'cancel', 'icon', 'cross', 'x', 'close', 'remove'],
		componentName: 'CrossIcon',
		package: '@atlaskit/icon/core/cross',
		categorization: 'multi-purpose',
		usage: 'Known uses: closing modals, panels, and transient views; removing tags',
		team: 'Design System Team',
		status: 'published',
	},
	'cross-circle': {
		keywords: [
			'cross-circle',
			'crosscircle',
			'close',
			'x',
			'cancel',
			'icon',
			'x',
			'exit',
			'clear',
			'no',
			'filled',
		],
		componentName: 'CrossCircleIcon',
		package: '@atlaskit/icon/core/cross-circle',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: clear text field, error status.',
		team: 'Design System Team',
		status: 'published',
	},
	'curly-brackets': {
		keywords: [
			'curly-brackets',
			'curlybrackets',
			'icon',
			'curly brackets',
			'braces',
			'smart value',
		],
		componentName: 'CurlyBracketsIcon',
		package: '@atlaskit/icon/core/curly-brackets',
		categorization: 'multi-purpose',
		usage: 'Known uses: Represents Smart values in Proforma.',
		team: 'Design System Team',
		status: 'published',
	},
	customize: {
		keywords: [
			'customize',
			'icon',
			'customise',
			'configure',
			'modify',
			'preferences',
			'settings',
			'sliders',
		],
		componentName: 'CustomizeIcon',
		package: '@atlaskit/icon/core/customize',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: customize sidebar, customize view, settings.',
		team: 'Design System Team',
		status: 'published',
	},
	dashboard: {
		keywords: ['dashboard', 'window', 'grid', 'icon', 'activity', 'view'],
		componentName: 'DashboardIcon',
		package: '@atlaskit/icon/core/dashboard',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for dashboards in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	'data-flow': {
		keywords: ['data-flow', 'dataflow', 'icon', 'relationship', 'data', 'flow chart'],
		componentName: 'DataFlowIcon',
		package: '@atlaskit/icon/core/data-flow',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known usages: Database schema in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	'data-number': {
		keywords: ['data-number', 'datanumber', 'icon', 'numbers', '123', 'proforma', 'datatype'],
		componentName: 'DataNumberIcon',
		package: '@atlaskit/icon/core/data-number',
		categorization: 'multi-purpose',
		usage: 'Known uses: Representing number datatype fields in Proforma and databases.',
		team: 'Design System Team',
		status: 'published',
	},
	'data-string': {
		keywords: [
			'data-string',
			'datastring',
			'icon',
			'string',
			'letters',
			'abc',
			'proforma',
			'datatype',
		],
		componentName: 'DataStringIcon',
		package: '@atlaskit/icon/core/data-string',
		categorization: 'multi-purpose',
		usage: 'Known uses: Representing string datatype fields in Proforma and databases.',
		team: 'Design System Team',
		status: 'published',
	},
	database: {
		keywords: ['database', 'icon', 'spreadsheet', 'table', 'data', 'cells'],
		componentName: 'DatabaseIcon',
		package: '@atlaskit/icon/core/database',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for databases in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	decision: {
		keywords: ['decision', 'icon', 'fork', 'diagonal arrow'],
		componentName: 'DecisionIcon',
		package: '@atlaskit/icon/core/decision',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for decisions.',
		team: 'Design System Team',
		status: 'published',
	},
	defect: {
		keywords: ['defect', 'icon', 'defect', 'fragile', 'cracked', 'work type'],
		componentName: 'DefectIcon',
		package: '@atlaskit/icon/core/defect',
		categorization: 'single-purpose',
		usage: 'Reserved for defect work type.',
		team: 'Design System Team',
		status: 'published',
	},
	delete: {
		keywords: ['delete', 'icon', 'trash', 'bin', 'remove'],
		componentName: 'DeleteIcon',
		package: '@atlaskit/icon/core/delete',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for removing or deleting an object.',
		team: 'Design System Team',
		status: 'published',
	},
	department: {
		keywords: ['department', 'icon', 'organization', 'organisation', 'org chart', 'hierarchy'],
		componentName: 'DepartmentIcon',
		package: '@atlaskit/icon/core/department',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for departments, reporting lines, or other tree chart representations.',
		team: 'Design System Team',
		status: 'published',
	},
	'device-mobile': {
		keywords: ['device-mobile', 'devicemobile', 'icon', 'iphone', 'mobile phone', 'cell phone'],
		componentName: 'DeviceMobileIcon',
		package: '@atlaskit/icon/core/device-mobile',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: call, contact us.',
		team: 'Design System Team',
		status: 'published',
	},
	devices: {
		keywords: ['devices', 'icon', 'devices', 'assets', 'laptop', 'phone', 'hardware', 'work type'],
		componentName: 'DevicesIcon',
		package: '@atlaskit/icon/core/devices',
		categorization: 'multi-purpose',
		usage: "Known usages: \'Asset\' work type.",
		team: 'Design System Team',
		status: 'published',
	},
	discovery: {
		keywords: ['discovery', 'icon', 'discovery', 'note', 'filled', 'onboarding', 'status'],
		componentName: 'DiscoveryIcon',
		package: '@atlaskit/icon/core/discovery',
		replacement: { name: 'status-discovery', location: '@atlaskit/icon' },
		categorization: 'single-purpose',
		usage:
			'Reserved for discovery statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.',
		team: 'Design System Team',
		status: 'deprecated',
	},
	download: {
		keywords: ['download', 'cloud', 'icon', 'down arrow', 'file download'],
		componentName: 'DownloadIcon',
		package: '@atlaskit/icon/core/download',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for file downloads.',
		team: 'Design System Team',
		status: 'published',
	},
	'drag-handle-horizontal': {
		keywords: [
			'drag-handle-horizontal',
			'draghandlehorizontal',
			'icon',
			'drag handler',
			'reorder',
			'move',
			'reorder horizontal',
		],
		componentName: 'DragHandleHorizontalIcon',
		package: '@atlaskit/icon/core/drag-handle-horizontal',
		categorization: 'single-purpose',
		usage: 'Reserved for dragging elements along a horizontal axis.',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'drag-handle-vertical': {
		keywords: [
			'drag-handle-vertical',
			'draghandlevertical',
			'icon',
			'drag handler',
			'reorder',
			'move',
			'reorder vertical',
		],
		componentName: 'DragHandleVerticalIcon',
		package: '@atlaskit/icon/core/drag-handle-vertical',
		categorization: 'single-purpose',
		usage: 'Reserved for dragging elements along a vertical axis.',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	edit: {
		keywords: ['edit', 'pencil', 'write', 'icon', 'pencil', 'pencil on page'],
		componentName: 'EditIcon',
		package: '@atlaskit/icon/core/edit',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for editing objects.',
		team: 'Design System Team',
		status: 'published',
	},
	'edit-bulk': {
		keywords: ['edit-bulk', 'editbulk', 'icon', 'edit', 'pencil', 'multiple', 'bulk', 'change'],
		componentName: 'EditBulkIcon',
		package: '@atlaskit/icon/core/edit-bulk',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for editing multiple objects in bulk.',
		team: 'Design System Team',
		status: 'published',
	},
	email: {
		keywords: ['email', 'icon', 'envelope', 'message'],
		componentName: 'EmailIcon',
		package: '@atlaskit/icon/core/email',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for when an email-related things.',
		team: 'Design System Team',
		status: 'published',
	},
	emoji: {
		keywords: ['emoji', 'emoticon', 'smiley', 'icon', 'smiley face', 'emoticon'],
		componentName: 'EmojiIcon',
		package: '@atlaskit/icon/core/emoji',
		categorization: 'single-purpose',
		usage: "Single purpose - Reserved for Editor as a category for Emoji\'s.",
		team: 'Design System Team',
		status: 'published',
	},
	'emoji-add': {
		keywords: ['emoji-add', 'emojiadd', 'icon', 'smiley face', 'emoticon', 'plus'],
		componentName: 'EmojiAddIcon',
		package: '@atlaskit/icon/core/emoji-add',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for adding an emoji reaction.',
		team: 'Design System Team',
		status: 'published',
	},
	'emoji-casual': {
		keywords: [
			'emoji-casual',
			'emojicasual',
			'icon',
			'emoij',
			'casual',
			'sunglasses',
			'chill',
			'relaxed',
		],
		componentName: 'EmojiCasualIcon',
		package: '@atlaskit/icon/core/emoji-casual',
		categorization: 'single-purpose',
		usage: 'Reserved for representing a casual or relaxed tone or sentiment.',
		team: 'Design System Team',
		status: 'published',
	},
	'emoji-neutral': {
		keywords: ['emoji-neutral', 'emojineutral', 'icon', 'emoji', 'neutral', 'ambivalent'],
		componentName: 'EmojiNeutralIcon',
		package: '@atlaskit/icon/core/emoji-neutral',
		categorization: 'single-purpose',
		usage: 'Reserved for representing a neutral tone or sentiment.',
		team: 'Design System Team',
		status: 'published',
	},
	'emoji-remove': {
		keywords: ['emoji-remove', 'emojiremove', 'icon', 'emoji', 'remove', 'strikethrough'],
		componentName: 'EmojiRemoveIcon',
		package: '@atlaskit/icon/core/emoji-remove',
		categorization: 'single-purpose',
		usage: 'Reserved for removing emoji.',
		team: 'Design System Team',
		status: 'published',
	},
	epic: {
		keywords: ['epic', 'icon', 'lightning bolt', 'jira status', 'filled'],
		componentName: 'EpicIcon',
		package: '@atlaskit/icon/core/epic',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for epics in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	error: {
		keywords: [
			'error',
			'warning',
			'alert',
			'icon',
			'filled',
			'status',
			'danger',
			'exclamation',
			'!',
			'error',
		],
		componentName: 'ErrorIcon',
		package: '@atlaskit/icon/core/error',
		replacement: { name: 'status-error', location: '@atlaskit/icon' },
		categorization: 'single-purpose',
		usage:
			'Reserved for error statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.',
		team: 'Design System Team',
		status: 'deprecated',
	},
	'exclamation-square': {
		keywords: [
			'exclamation-square',
			'exclamationsquare',
			'icon',
			'!',
			'exclaim',
			'square',
			'work type',
		],
		componentName: 'ExclamationSquareIcon',
		package: '@atlaskit/icon/core/exclamation-square',
		categorization: 'multi-purpose',
		usage: 'Known uses: Exclamation work type.',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'expand-horizontal': {
		keywords: [
			'expand-horizontal',
			'expandhorizontal',
			'icon',
			'expand',
			'width',
			'horizontal arrows',
			'maximum width',
			'stretch',
			'fit',
		],
		componentName: 'ExpandHorizontalIcon',
		package: '@atlaskit/icon/core/expand-horizontal',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for expanding an element to its maximum width.',
		team: 'Design System Team',
		status: 'published',
	},
	'expand-vertical': {
		keywords: [
			'expand-vertical',
			'expandvertical',
			'icon',
			'expand',
			'height',
			'vertical arrows',
			'maximum height',
			'stretch',
			'fit',
		],
		componentName: 'ExpandVerticalIcon',
		package: '@atlaskit/icon/core/expand-vertical',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for expanding an element to its maximum height.',
		team: 'Design System Team',
		status: 'published',
	},
	'eye-open': {
		keywords: ['eye-open', 'eyeopen', 'icon', 'watch', 'visible', 'visbility', 'permissions'],
		componentName: 'EyeOpenIcon',
		package: '@atlaskit/icon/core/eye-open',
		categorization: 'multi-purpose',
		usage:
			'Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.',
		team: 'Design System Team',
		status: 'published',
	},
	'eye-open-filled': {
		keywords: [
			'eye-open-filled',
			'eyeopenfilled',
			'icon',
			'watching',
			'visible',
			'visbility',
			'permissions',
			'filled',
		],
		componentName: 'EyeOpenFilledIcon',
		package: '@atlaskit/icon/core/eye-open-filled',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: watched pages in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	'eye-open-strikethrough': {
		keywords: [
			'eye-open-strikethrough',
			'eyeopenstrikethrough',
			'icon',
			'unwatch',
			'invisible',
			'visibility',
			'permissions',
		],
		componentName: 'EyeOpenStrikethroughIcon',
		package: '@atlaskit/icon/core/eye-open-strikethrough',
		categorization: 'multi-purpose',
		usage:
			'Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.',
		team: 'Design System Team',
		status: 'published',
	},
	feed: {
		keywords: ['feed', 'icon', 'feed', 'updates', 'release notes', "what's new"],
		componentName: 'FeedIcon',
		package: '@atlaskit/icon/core/feed',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for update feeds in Atlassian Home.',
		team: 'Design System Team',
		status: 'published',
	},
	feedback: {
		keywords: [
			'feedback',
			'announce',
			'speaker',
			'megaphone',
			'icon',
			'diagonal arrow',
			'chat bubble',
			'survey',
			'critique',
		],
		componentName: 'FeedbackIcon',
		package: '@atlaskit/icon/core/feedback',
		categorization: 'single-purpose',
		usage: 'Single purpose - Known uses: customer feedback.',
		team: 'Design System Team',
		status: 'published',
	},
	field: {
		keywords: ['field', 'icon', 'field', 'form', 'input', 'label'],
		componentName: 'FieldIcon',
		package: '@atlaskit/icon/core/field',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known usages: Field suggestions provided by Atlassian Intelligence.',
		team: 'Design System Team',
		status: 'published',
	},
	'field-alert': {
		keywords: ['field-alert', 'fieldalert', 'icon', 'field', 'alert', 'warning', 'change'],
		componentName: 'FieldAlertIcon',
		package: '@atlaskit/icon/core/field-alert',
		categorization: 'multi-purpose',
		usage: 'Known uses: Changed field values in Automation.',
		team: 'Design System Team',
		status: 'published',
	},
	'field-checkbox-group': {
		keywords: [
			'field-checkbox-group',
			'fieldcheckboxgroup',
			'icon',
			'form',
			'field',
			'input type',
			'checkbox',
			'multi-select',
			'options',
		],
		componentName: 'FieldCheckboxGroupIcon',
		package: '@atlaskit/icon/core/field-checkbox-group',
		categorization: 'multi-purpose',
		usage: 'Known uses: Checkbox group field type in Proforma.',
		team: 'Design System Team',
		status: 'published',
	},
	'field-dropdown': {
		keywords: ['field-dropdown', 'fielddropdown', 'icon', 'form', 'field', 'select', 'dropdown'],
		componentName: 'FieldDropdownIcon',
		package: '@atlaskit/icon/core/field-dropdown',
		categorization: 'multi-purpose',
		usage: 'Known uses: Dropdown field type in Proforma.',
		team: 'Design System Team',
		status: 'published',
	},
	'field-radio-group': {
		keywords: [
			'field-radio-group',
			'fieldradiogroup',
			'icon',
			'form',
			'field',
			'input type',
			'radio',
			'single-select',
			'options',
		],
		componentName: 'FieldRadioGroupIcon',
		package: '@atlaskit/icon/core/field-radio-group',
		categorization: 'multi-purpose',
		usage: 'Known uses: Radio group field type in Proforma.',
		team: 'Design System Team',
		status: 'published',
	},
	file: {
		keywords: ['file', 'document', 'paper', 'page', 'sheet', 'icon', 'document', 'file', 'paper'],
		componentName: 'FileIcon',
		package: '@atlaskit/icon/core/file',
		categorization: 'multi-purpose',
		usage:
			"Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated \'Page\' icon instead.",
		team: 'Design System Team',
		status: 'published',
	},
	files: {
		keywords: ['files', 'icon', 'documents', 'files', 'papers'],
		componentName: 'FilesIcon',
		package: '@atlaskit/icon/core/files',
		categorization: 'multi-purpose',
		usage:
			"Multi purpose - Known uses: documents, files. Do not use to represent pages — use the dedicated \'Pages\' icon instead.",
		team: 'Design System Team',
		status: 'published',
	},
	filter: {
		keywords: ['filter', 'icon', 'funnel', 'refine'],
		componentName: 'FilterIcon',
		package: '@atlaskit/icon/core/filter',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for filterting data or objects.',
		team: 'Design System Team',
		status: 'published',
	},
	flag: {
		keywords: ['flag', 'icon', 'important', 'emoji category'],
		componentName: 'FlagIcon',
		package: '@atlaskit/icon/core/flag',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: flags in Editor, feature flags.',
		team: 'Design System Team',
		status: 'published',
	},
	'flag-filled': {
		keywords: ['flag-filled', 'flagfilled', 'icon', 'flag', 'important', 'filled'],
		componentName: 'FlagFilledIcon',
		package: '@atlaskit/icon/core/flag-filled',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: active feature flags.',
		team: 'Design System Team',
		status: 'published',
	},
	flask: {
		keywords: ['flask', 'icon', 'labs', 'test', 'erlenmeyer flask', 'beaker'],
		componentName: 'FlaskIcon',
		package: '@atlaskit/icon/core/flask',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: labs in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	'focus-area': {
		keywords: ['focus-area', 'focusarea', 'icon', 'focus', 'focus area', 'capture'],
		componentName: 'FocusAreaIcon',
		package: '@atlaskit/icon/core/focus-area',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Focus Areas.',
		team: 'Design System Team',
		status: 'published',
	},
	'folder-closed': {
		keywords: ['folder-closed', 'folderclosed', 'icon', 'directory'],
		componentName: 'FolderClosedIcon',
		package: '@atlaskit/icon/core/folder-closed',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for folders in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	'folder-open': {
		keywords: ['folder-open', 'folderopen', 'icon', 'directory'],
		componentName: 'FolderOpenIcon',
		package: '@atlaskit/icon/core/folder-open',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for open folders in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	form: {
		keywords: ['form', 'icon', 'form', 'fields'],
		componentName: 'FormIcon',
		package: '@atlaskit/icon/core/form',
		categorization: 'multi-purpose',
		usage: 'Known uses: Represents forms across Atlassian apps, including Proforma.',
		team: 'Design System Team',
		status: 'published',
	},
	'fullscreen-enter': {
		keywords: ['fullscreen-enter', 'fullscreenenter', 'icon', 'full screen'],
		componentName: 'FullscreenEnterIcon',
		package: '@atlaskit/icon/core/fullscreen-enter',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for full screen videos or objects.',
		team: 'Design System Team',
		status: 'published',
	},
	'fullscreen-exit': {
		keywords: ['fullscreen-exit', 'fullscreenexit', 'icon', 'un-full screen', 'un-fullscreen'],
		componentName: 'FullscreenExitIcon',
		package: '@atlaskit/icon/core/fullscreen-exit',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for return screen videos or objects.',
		team: 'Design System Team',
		status: 'published',
	},
	glasses: {
		keywords: ['glasses', 'icon', 'glasses', 'knowledge', 'learning', 'spectacles', 'education'],
		componentName: 'GlassesIcon',
		package: '@atlaskit/icon/core/glasses',
		categorization: 'multi-purpose',
		usage:
			'Known uses: Changing tone of written content to Educational with Atlassian Intelligence.',
		team: 'Design System Team',
		status: 'published',
	},
	globe: {
		keywords: ['globe', 'icon', 'world'],
		componentName: 'GlobeIcon',
		package: '@atlaskit/icon/core/globe',
		categorization: 'multi-purpose',
		usage:
			'Multi purpose - Known uses: public link in Confluence share dialog, global rules in Automation.',
		team: 'Design System Team',
		status: 'published',
	},
	goal: {
		keywords: ['goal', 'icon', 'target'],
		componentName: 'GoalIcon',
		package: '@atlaskit/icon/core/goal',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for goals in Atlas.',
		team: 'Design System Team',
		status: 'published',
	},
	grid: {
		keywords: ['grid', 'icon', 'view all content', 'tile view', 'layout', 'grid', 'tiles'],
		componentName: 'GridIcon',
		package: '@atlaskit/icon/core/grid',
		categorization: 'multi-purpose',
		usage:
			'Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	'grow-diagonal': {
		keywords: [
			'grow-diagonal',
			'growdiagonal',
			'icon',
			'grow',
			'width and height',
			'diagonal arrows',
		],
		componentName: 'GrowDiagonalIcon',
		package: '@atlaskit/icon/core/grow-diagonal',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.',
		team: 'Design System Team',
		status: 'published',
	},
	'grow-horizontal': {
		keywords: ['grow-horizontal', 'growhorizontal', 'icon', 'grow', 'width', 'horizontal arrows'],
		componentName: 'GrowHorizontalIcon',
		package: '@atlaskit/icon/core/grow-horizontal',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for increasing the width of an element.',
		team: 'Design System Team',
		status: 'published',
	},
	'grow-vertical': {
		keywords: ['grow-vertical', 'growvertical', 'icon', 'grow', 'height', 'vertical arrows'],
		componentName: 'GrowVerticalIcon',
		package: '@atlaskit/icon/core/grow-vertical',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for increasing the height of an element.',
		team: 'Design System Team',
		status: 'published',
	},
	hashtag: {
		keywords: ['hashtag', 'icon', 'tag', 'topic', 'pound'],
		componentName: 'HashtagIcon',
		package: '@atlaskit/icon/core/hashtag',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: topics in Atlas, tags.',
		team: 'Design System Team',
		status: 'published',
	},
	headphones: {
		keywords: ['headphones', 'icon', 'audio', 'music', 'headphones'],
		componentName: 'HeadphonesIcon',
		package: '@atlaskit/icon/core/headphones',
		categorization: 'multi-purpose',
		usage: 'Known uses: music, audio.',
		team: 'Design System Team',
		status: 'published',
	},
	heart: {
		keywords: ['heart', 'icon', 'like', 'love', 'emoji category'],
		componentName: 'HeartIcon',
		package: '@atlaskit/icon/core/heart',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: emoji symbols in Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	highlight: {
		keywords: ['highlight', 'icon', 'highlight', 'highlighter', 'stabilo', 'pen'],
		componentName: 'HighlightIcon',
		package: '@atlaskit/icon/core/highlight',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for highlight text tool in Confluence Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	home: {
		keywords: ['home', 'icon', 'house', 'building'],
		componentName: 'HomeIcon',
		package: '@atlaskit/icon/core/home',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.',
		team: 'Design System Team',
		status: 'published',
	},
	image: {
		keywords: ['image', 'picture', 'photo', 'icon', 'picture', 'asset'],
		componentName: 'ImageIcon',
		package: '@atlaskit/icon/core/image',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: images, image upload.',
		team: 'Design System Team',
		status: 'published',
	},
	'image-fullscreen': {
		keywords: ['image-fullscreen', 'imagefullscreen', 'icon', 'image', 'fullscreen', 'enlarge'],
		componentName: 'ImageFullscreenIcon',
		package: '@atlaskit/icon/core/image-fullscreen',
		categorization: 'single-purpose',
		usage: 'Reserved for viewing an image in a fullscreen view or modal.',
		team: 'Editor',
		status: 'published',
	},
	'image-inline': {
		keywords: ['image-inline', 'imageinline', 'icon', 'image', 'layout', 'inline'],
		componentName: 'ImageInlineIcon',
		package: '@atlaskit/icon/core/image-inline',
		categorization: 'single-purpose',
		usage: 'Reserved for representing inline images in Editor.',
		team: 'Editor',
		status: 'published',
	},
	'image-scaled': {
		keywords: ['image-scaled', 'imagescaled', 'icon', 'image', 'layout', 'scaled'],
		componentName: 'ImageScaledIcon',
		package: '@atlaskit/icon/core/image-scaled',
		categorization: 'single-purpose',
		usage: 'Reserved for representing scaled images in layouts akin to display block.',
		team: 'Editor',
		status: 'published',
	},
	inbox: {
		keywords: ['inbox', 'icon', 'document tray', 'work', 'letter', 'post'],
		componentName: 'InboxIcon',
		package: '@atlaskit/icon/core/inbox',
		categorization: 'multi-purpose',
		usage: "Multi purpose - Known uses: \'Your work\' in Confluence, inbox, mail.",
		team: 'Design System Team',
		status: 'published',
	},
	incident: {
		keywords: ['incident', 'icon', 'witches hat', 'traffic cone', 'jira status'],
		componentName: 'IncidentIcon',
		package: '@atlaskit/icon/core/incident',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for incidents in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	information: {
		keywords: ['information', 'icon', 'info', 'filled', 'status', 'information'],
		componentName: 'InformationIcon',
		package: '@atlaskit/icon/core/information',
		replacement: { name: 'status-information', location: '@atlaskit/icon' },
		categorization: 'single-purpose',
		usage:
			"Reserved for information statuses and messaging.  Filled status icons provide higher visual contrast to draw attention to important information. For information tooltips, use the unfilled \'information circle\' icon.",
		team: 'Design System Team',
		status: 'deprecated',
	},
	'information-circle': {
		keywords: ['information-circle', 'informationcircle', 'icon', 'information', 'circle', 'info'],
		componentName: 'InformationCircleIcon',
		package: '@atlaskit/icon/core/information-circle',
		categorization: 'multi-purpose',
		usage:
			'Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'key-result': {
		keywords: [
			'key-result',
			'keyresult',
			'icon',
			'target',
			'bullseye',
			'key result',
			'arrow',
			'bow',
			'archery',
			'OKR',
		],
		componentName: 'KeyResultIcon',
		package: '@atlaskit/icon/core/key-result',
		categorization: 'single-purpose',
		usage: 'Reserved for representing key results.',
		team: 'Atlas',
		status: 'published',
	},
	'layout-one-column': {
		keywords: ['layout-one-column', 'layoutonecolumn', 'icon', 'layout', 'column', '1 col'],
		componentName: 'LayoutOneColumnIcon',
		package: '@atlaskit/icon/core/layout-one-column',
		categorization: 'single-purpose',
		usage: 'Reserved for single column layout option in Confluence Editor',
		team: 'Design System Team',
		status: 'published',
	},
	'layout-three-columns': {
		keywords: [
			'layout-three-columns',
			'layoutthreecolumns',
			'icon',
			'layout',
			'columns',
			'3 col',
			'3 cols',
		],
		componentName: 'LayoutThreeColumnsIcon',
		package: '@atlaskit/icon/core/layout-three-columns',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for 3 column layout option in Confluence Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	'layout-three-columns-sidebars': {
		keywords: [
			'layout-three-columns-sidebars',
			'layoutthreecolumnssidebars',
			'icon',
			'layout',
			'columns',
			'3 col',
			'3 cols',
			'sidebars',
			'asides',
		],
		componentName: 'LayoutThreeColumnsSidebarsIcon',
		package: '@atlaskit/icon/core/layout-three-columns-sidebars',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for 3 column layout with left and right sidebars option in Confluence Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	'layout-two-columns': {
		keywords: [
			'layout-two-columns',
			'layouttwocolumns',
			'icon',
			'layout',
			'columns',
			'2 col',
			'2 cols',
		],
		componentName: 'LayoutTwoColumnsIcon',
		package: '@atlaskit/icon/core/layout-two-columns',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for 2 column layout option in Confluence Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	'layout-two-columns-sidebar-left': {
		keywords: [
			'layout-two-columns-sidebar-left',
			'layouttwocolumnssidebarleft',
			'icon',
			'layout',
			'columns',
			'2 col',
			'2 cols',
			'sidebar',
			'aside',
		],
		componentName: 'LayoutTwoColumnsSidebarLeftIcon',
		package: '@atlaskit/icon/core/layout-two-columns-sidebar-left',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	'layout-two-columns-sidebar-right': {
		keywords: [
			'layout-two-columns-sidebar-right',
			'layouttwocolumnssidebarright',
			'icon',
			'layout',
			'columns',
			'2 col',
			'2 cols',
			'sidebar',
			'aside',
		],
		componentName: 'LayoutTwoColumnsSidebarRightIcon',
		package: '@atlaskit/icon/core/layout-two-columns-sidebar-right',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for 2 column layout with right sidebar option in Confluence Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	library: {
		keywords: ['library', 'icon', 'library', 'drawer', 'drawers', 'filing cabinet'],
		componentName: 'LibraryIcon',
		package: '@atlaskit/icon/core/library',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for library view in Atlassian Home.',
		team: 'Design System Team',
		status: 'published',
	},
	lightbulb: {
		keywords: ['lightbulb', 'idea', 'hint', 'icon', 'idea', 'initiative', 'tip', 'learnings'],
		componentName: 'LightbulbIcon',
		package: '@atlaskit/icon/core/lightbulb',
		categorization: 'multi-purpose',
		usage: 'Known uses: learnings in Atlas.',
		team: 'Design System Team',
		status: 'published',
	},
	link: {
		keywords: ['link', 'icon', 'url', 'hyperlink', 'website', 'www', 'http', ''],
		componentName: 'LinkIcon',
		package: '@atlaskit/icon/core/link',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for links, urls, or copy link.',
		team: 'Design System Team',
		status: 'published',
	},
	'link-broken': {
		keywords: [
			'link-broken',
			'linkbroken',
			'icon',
			'unlink',
			'remove link',
			'break link',
			'url',
			'hyperlink',
			'website',
			'www',
			'https',
		],
		componentName: 'LinkBrokenIcon',
		package: '@atlaskit/icon/core/link-broken',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for removing a link.',
		team: 'Design System Team',
		status: 'published',
	},
	'link-external': {
		keywords: [
			'link-external',
			'linkexternal',
			'icon',
			'new tab',
			'new window',
			'open in',
			'url',
			'hyperlink',
			'www',
			'http',
			'https',
			'website',
			'external',
			'shortcut',
			'diagonal arrow',
			'offsite',
		],
		componentName: 'LinkExternalIcon',
		package: '@atlaskit/icon/core/link-external',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for links that open up a new tab.',
		team: 'Design System Team',
		status: 'published',
	},
	'list-bulleted': {
		keywords: ['list-bulleted', 'listbulleted', 'icon', 'bullets', 'unordered list'],
		componentName: 'ListBulletedIcon',
		package: '@atlaskit/icon/core/list-bulleted',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: bulleted lists, view all.',
		team: 'Design System Team',
		status: 'published',
	},
	'list-checklist': {
		keywords: [
			'list-checklist',
			'listchecklist',
			'icon',
			'list',
			'check mark',
			'to-do',
			'requirements',
			'checklist',
			'work type',
		],
		componentName: 'ListChecklistIcon',
		package: '@atlaskit/icon/core/list-checklist',
		categorization: 'multi-purpose',
		usage: "Known usages: Checklist, \'Requirement\' work type.",
		team: 'Design System Team',
		status: 'published',
	},
	'list-numbered': {
		keywords: ['list-numbered', 'listnumbered', 'icon', 'list', 'numbers'],
		componentName: 'ListNumberedIcon',
		package: '@atlaskit/icon/core/list-numbered',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known usages: Numbered list in Confluence Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	'lobby-bell': {
		keywords: ['lobby-bell', 'lobbybell', 'icon', 'ding', 'risks'],
		componentName: 'LobbyBellIcon',
		package: '@atlaskit/icon/core/lobby-bell',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: risks in Atlas.',
		team: 'Design System Team',
		status: 'published',
	},
	location: {
		keywords: ['location', 'pin', 'gps', 'map', 'icon', 'map', 'pin', 'address'],
		componentName: 'LocationIcon',
		package: '@atlaskit/icon/core/location',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: location in Atlas.',
		team: 'Design System Team',
		status: 'published',
	},
	'lock-locked': {
		keywords: [
			'lock-locked',
			'locklocked',
			'icon',
			'permissions',
			'no access',
			'restricted',
			'security',
			'secure',
			'forbidden',
			'authentication',
		],
		componentName: 'LockLockedIcon',
		package: '@atlaskit/icon/core/lock-locked',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: secure password in textfields, locked page in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	'lock-unlocked': {
		keywords: [
			'lock-unlocked',
			'lockunlocked',
			'icon',
			'open permissions',
			'unrestricted access',
			'security',
			'insecure',
			'authentication',
		],
		componentName: 'LockUnlockedIcon',
		package: '@atlaskit/icon/core/lock-unlocked',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: unlocked page in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	'log-in': {
		keywords: ['log-in', 'login', 'icon', 'sign in', 'enter', 'account'],
		componentName: 'LogInIcon',
		package: '@atlaskit/icon/core/log-in',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for log in.',
		team: 'Design System Team',
		status: 'published',
	},
	'log-out': {
		keywords: ['log-out', 'logout', 'icon', 'sign out', 'exit', 'account'],
		componentName: 'LogOutIcon',
		package: '@atlaskit/icon/core/log-out',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for log out.',
		team: 'Design System Team',
		status: 'published',
	},
	'magic-wand': {
		keywords: ['magic-wand', 'magicwand', 'icon', 'magic', 'wand', 'suggestion'],
		componentName: 'MagicWandIcon',
		package: '@atlaskit/icon/core/magic-wand',
		categorization: 'multi-purpose',
		usage: 'Multi purpose',
		team: 'Design System Team',
		status: 'published',
	},
	markdown: {
		keywords: ['markdown', 'icon', 'markdown', 'md', 'markup'],
		componentName: 'MarkdownIcon',
		package: '@atlaskit/icon/core/markdown',
		categorization: 'single-purpose',
		usage: 'Reserved for representing the Markdown markup language.',
		team: 'Design System Team',
		status: 'published',
	},
	marketplace: {
		keywords: [
			'marketplace',
			'store',
			'shop',
			'icon',
			'app store',
			'storefront',
			'stand',
			'third-party developer',
		],
		componentName: 'MarketplaceIcon',
		package: '@atlaskit/icon/core/marketplace',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for Atlassian Marketplace.',
		team: 'Design System Team',
		status: 'published',
	},
	maximize: {
		keywords: ['maximize', 'icon', 'diagonal', 'resize', 'enlarge'],
		componentName: 'MaximizeIcon',
		package: '@atlaskit/icon/core/maximize',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for resizing screens, panels, modals, or media to its maximum size.',
		team: 'Design System Team',
		status: 'published',
	},
	megaphone: {
		keywords: ['megaphone', 'icon', 'announcement', 'bullhorn', 'feedback', 'news'],
		componentName: 'MegaphoneIcon',
		package: '@atlaskit/icon/core/megaphone',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: feedback in apps.',
		team: 'Design System Team',
		status: 'published',
	},
	mention: {
		keywords: ['mention', 'user', 'person', '@', 'icon', 'at symbol', '@', 'tag', 'username'],
		componentName: 'MentionIcon',
		package: '@atlaskit/icon/core/mention',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for user mentions.',
		team: 'Design System Team',
		status: 'published',
	},
	menu: {
		keywords: [
			'menu',
			'hamburger',
			'navigation',
			'switcher',
			'app switcher',
			'icon',
			'menu',
			'top navigation',
			'3 lines',
			'hamburger',
		],
		componentName: 'MenuIcon',
		package: '@atlaskit/icon/core/menu',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for accessing the menu in global app navigation.',
		team: 'Design System Team',
		status: 'published',
	},
	'merge-failure': {
		keywords: [
			'merge-failure',
			'mergefailure',
			'icon',
			'git merge',
			'bitbucket merge',
			'merge fail',
			'cross',
			'x',
		],
		componentName: 'MergeFailureIcon',
		package: '@atlaskit/icon/core/merge-failure',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for branches in Bitbucket and Jira that have failed to merge.',
		team: 'Design System Team',
		status: 'published',
	},
	'merge-success': {
		keywords: [
			'merge-success',
			'mergesuccess',
			'icon',
			'git merge',
			'bitbucket merge',
			'merge success',
			'check mark',
		],
		componentName: 'MergeSuccessIcon',
		package: '@atlaskit/icon/core/merge-success',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for branches in Bitbucket and Jira that have successfully merged.',
		team: 'Design System Team',
		status: 'published',
	},
	microphone: {
		keywords: ['microphone', 'icon', 'mic', 'mic on', 'voice', 'speak'],
		componentName: 'MicrophoneIcon',
		package: '@atlaskit/icon/core/microphone',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: record sounds in Trello.',
		team: 'Design System Team',
		status: 'published',
	},
	minimize: {
		keywords: ['minimize', 'icon', 'minimize', 'dock'],
		componentName: 'MinimizeIcon',
		package: '@atlaskit/icon/core/minimize',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for minimizing or docking modals to the bottom of the viewport.',
		team: 'Design System Team',
		status: 'published',
	},
	minus: {
		keywords: ['minus', 'icon', 'rule', 'horizontal line', 'divider', 'minus', 'subtract'],
		componentName: 'MinusIcon',
		package: '@atlaskit/icon/core/minus',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: horizontal rule in Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	'minus-square': {
		keywords: ['minus-square', 'minussquare', 'icon', 'square', 'minus', 'subtract', 'work type'],
		componentName: 'MinusSquareIcon',
		package: '@atlaskit/icon/core/minus-square',
		categorization: 'multi-purpose',
		usage: "Known usages: \'Remove feature\' work type.",
		team: 'Design System Team',
		status: 'published',
	},
	node: {
		keywords: ['node', 'icon', 'page', 'dot', 'page tree', 'navigation'],
		componentName: 'NodeIcon',
		package: '@atlaskit/icon/core/node',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for a non-expandable item in a page tree.',
		team: 'Design System Team',
		status: 'published',
	},
	note: {
		keywords: ['note', 'icon', 'note', 'post-it', 'sticky'],
		componentName: 'NoteIcon',
		package: '@atlaskit/icon/core/note',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for notes.',
		team: 'Design System Team',
		status: 'published',
	},
	notification: {
		keywords: ['notification', 'bell', 'alarm', 'icon', 'bell', 'alert'],
		componentName: 'NotificationIcon',
		package: '@atlaskit/icon/core/notification',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for notifications within global app navigation and within app screens.',
		team: 'Design System Team',
		status: 'published',
	},
	'notification-muted': {
		keywords: [
			'notification-muted',
			'notificationmuted',
			'icon',
			'bell',
			'alert',
			'notification',
			'mute',
		],
		componentName: 'NotificationMutedIcon',
		package: '@atlaskit/icon/core/notification-muted',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for muting or disabling notifications.',
		team: 'Design System Team',
		status: 'published',
	},
	objective: {
		keywords: ['objective', 'icon', 'target', 'bullseye', 'objective'],
		componentName: 'ObjectiveIcon',
		package: '@atlaskit/icon/core/objective',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for objectives.',
		team: 'Design System Team',
		status: 'published',
	},
	'office-building': {
		keywords: [
			'office-building',
			'officebuilding',
			'icon',
			'organization',
			'organisation',
			'business',
		],
		componentName: 'OfficeBuildingIcon',
		package: '@atlaskit/icon/core/office-building',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: office in Atlas, company.',
		team: 'Design System Team',
		status: 'published',
	},
	'on-call': {
		keywords: ['on-call', 'oncall', 'icon', 'phone', 'on-call', 'support'],
		componentName: 'OnCallIcon',
		package: '@atlaskit/icon/core/on-call',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for representing on-call across Atlassian apps.',
		team: 'Design System Team',
		status: 'published',
	},
	operations: {
		keywords: [
			'operations',
			'icon',
			'incident management',
			'alerting',
			'opsgenie',
			'it operations',
			'it ops',
			'radar',
		],
		componentName: 'OperationsIcon',
		package: '@atlaskit/icon/core/operations',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for IT Operations.',
		team: 'Design System Team',
		status: 'published',
	},
	page: {
		keywords: [
			'page',
			'file',
			'document',
			'icon',
			'single page',
			'feed',
			'document',
			'jira status',
		],
		componentName: 'PageIcon',
		package: '@atlaskit/icon/core/page',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for pages in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	pages: {
		keywords: ['pages', 'icon', 'multiple pages', 'feeds', 'documents'],
		componentName: 'PagesIcon',
		package: '@atlaskit/icon/core/pages',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for multipe pages in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	'paint-bucket': {
		keywords: [
			'paint-bucket',
			'paintbucket',
			'icon',
			'paint',
			'bucket',
			'fill',
			'background',
			'customize',
		],
		componentName: 'PaintBucketIcon',
		package: '@atlaskit/icon/core/paint-bucket',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known usages: Customize fill color.',
		team: 'Design System Team',
		status: 'published',
	},
	'paint-palette': {
		keywords: ['paint-palette', 'paintpalette', 'icon', 'background', 'customize'],
		componentName: 'PaintPaletteIcon',
		package: '@atlaskit/icon/core/paint-palette',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known usages: Customize.',
		team: 'Design System Team',
		status: 'published',
	},
	'panel-left': {
		keywords: [
			'panel-left',
			'panelleft',
			'icon',
			'detail view',
			'left rail',
			'drawer',
			'preview panel',
			'sidebar',
		],
		componentName: 'PanelLeftIcon',
		package: '@atlaskit/icon/core/panel-left',
		categorization: 'single-purpose',
		usage:
			'Reserved for opening a preview panel to the left of the viewport edge. Use for right-to-left languages which invert the navigational chrome.',
		team: 'Design System Team',
		status: 'published',
	},
	'panel-right': {
		keywords: [
			'panel-right',
			'panelright',
			'icon',
			'detail view',
			'right rail',
			'drawer',
			'preview panel',
			'sidebar',
		],
		componentName: 'PanelRightIcon',
		package: '@atlaskit/icon/core/panel-right',
		categorization: 'single-purpose',
		usage:
			'Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.',
		team: 'Design System Team',
		status: 'published',
	},
	pen: {
		keywords: ['pen', 'icon', 'pen tool', 'nib', 'fountain pen', 'design', 'work type'],
		componentName: 'PenIcon',
		package: '@atlaskit/icon/core/pen',
		categorization: 'multi-purpose',
		usage: "Known usages: \'Design task\' work type.",
		team: 'Design System Team',
		status: 'published',
	},
	'people-group': {
		keywords: [
			'people-group',
			'peoplegroup',
			'person',
			'user',
			'group',
			'icon',
			'users',
			'customers',
			'people',
		],
		componentName: 'PeopleGroupIcon',
		package: '@atlaskit/icon/core/people-group',
		categorization: 'single-purpose',
		usage: 'Single purpose - Known uses: representing a group or collection of people or users.',
		team: 'Design System Team',
		status: 'published',
	},
	person: {
		keywords: ['person', 'person', 'user', 'avatar', 'icon', 'user', 'customer'],
		componentName: 'PersonIcon',
		package: '@atlaskit/icon/core/person',
		categorization: 'single-purpose',
		usage: 'Single purpose - Known uses: representing a person or user, owner, contributor.',
		team: 'Design System Team',
		status: 'published',
	},
	'person-add': {
		keywords: ['person-add', 'personadd', 'icon', 'user', 'customer', 'plus'],
		componentName: 'PersonAddIcon',
		package: '@atlaskit/icon/core/person-add',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for adding a user to an object.',
		team: 'Design System Team',
		status: 'ready-to-publish',
	},
	'person-added': {
		keywords: ['person-added', 'personadded', 'icon', 'user', 'customer', 'check', 'tick'],
		componentName: 'PersonAddedIcon',
		package: '@atlaskit/icon/core/person-added',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for a user added to an object.',
		team: 'Design System Team',
		status: 'ready-to-publish',
	},
	'person-avatar': {
		keywords: ['person-avatar', 'personavatar', 'icon', 'user', 'customer'],
		componentName: 'PersonAvatarIcon',
		package: '@atlaskit/icon/core/person-avatar',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for user avatar.',
		team: 'Design System Team',
		status: 'published',
	},
	'person-offboard': {
		keywords: ['person-offboard', 'personoffboard', 'icon', 'user', 'customer', 'right arrow'],
		componentName: 'PersonOffboardIcon',
		package: '@atlaskit/icon/core/person-offboard',
		categorization: 'single-purpose',
		usage: '📦 @atlaskit/icon/core/person-offboard',
		team: 'Design System Team',
		status: 'published',
	},
	'person-remove': {
		keywords: ['person-remove', 'personremove', 'icon', 'person', 'remove', 'delete', 'unfollow'],
		componentName: 'PersonRemoveIcon',
		package: '@atlaskit/icon/core/person-remove',
		categorization: 'single-purpose',
		usage: 'Reserved for removing and unfollowing people and teammates.',
		team: 'Design System Team',
		status: 'published',
	},
	'person-warning': {
		keywords: ['person-warning', 'personwarning', 'icon', 'person', 'warning', 'alert'],
		componentName: 'PersonWarningIcon',
		package: '@atlaskit/icon/core/person-warning',
		categorization: 'single-purpose',
		usage: 'Reserved for showing a warning related to a person or teammate.',
		team: 'Design System Team',
		status: 'published',
	},
	phone: {
		keywords: ['phone', 'icon', 'call', 'dial out'],
		componentName: 'PhoneIcon',
		package: '@atlaskit/icon/core/phone',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: call us, phone number input.',
		team: 'Design System Team',
		status: 'published',
	},
	pin: {
		keywords: ['pin', 'icon', 'push pin', 'thumbtack', 'tack'],
		componentName: 'PinIcon',
		package: '@atlaskit/icon/core/pin',
		categorization: 'multi-purpose',
		usage: 'Known uses: unpinned fields.',
		team: 'Design System Team',
		status: 'published',
	},
	'pin-filled': {
		keywords: ['pin-filled', 'pinfilled', 'icon', 'push pin', 'thumbtack', 'tack', 'filled'],
		componentName: 'PinFilledIcon',
		package: '@atlaskit/icon/core/pin-filled',
		categorization: 'multi-purpose',
		usage: 'Known uses: pinned fields.',
		team: 'Design System Team',
		status: 'published',
	},
	'plus-square': {
		keywords: ['plus-square', 'plussquare', 'icon', 'square', 'plus', 'add', 'work type'],
		componentName: 'PlusSquareIcon',
		package: '@atlaskit/icon/core/plus-square',
		categorization: 'multi-purpose',
		usage: "Known usages: \'New feature\' work type.",
		team: 'Design System Team',
		status: 'published',
	},
	'power-plug': {
		keywords: ['power-plug', 'powerplug', 'icon', 'plug-in', 'add-on', 'socket'],
		componentName: 'PowerPlugIcon',
		package: '@atlaskit/icon/core/power-plug',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: plugins, add ons.',
		team: 'Design System Team',
		status: 'published',
	},
	premium: {
		keywords: ['premium', 'icon', 'AI', 'sparkles', 'stars', 'new', 'feature'],
		componentName: 'PremiumIcon',
		package: '@atlaskit/icon/core/premium',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for premium features.',
		team: 'Design System Team',
		status: 'published',
	},
	'presenter-mode': {
		keywords: [
			'presenter-mode',
			'presentermode',
			'icon',
			'pointer',
			'cursor',
			'presentation',
			'present',
		],
		componentName: 'PresenterModeIcon',
		package: '@atlaskit/icon/core/presenter-mode',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for presenter mode in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	printer: {
		keywords: ['printer', 'icon', 'print'],
		componentName: 'PrinterIcon',
		package: '@atlaskit/icon/core/printer',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: print page, print-friendly view.',
		team: 'Design System Team',
		status: 'published',
	},
	'priority-blocker': {
		keywords: [
			'priority-blocker',
			'priorityblocker',
			'icon',
			'blocked',
			'showstopper',
			'work type status',
		],
		componentName: 'PriorityBlockerIcon',
		package: '@atlaskit/icon/core/priority-blocker',
		categorization: 'single-purpose',
		usage: 'Reserved for blocker work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	'priority-critical': {
		keywords: ['priority-critical', 'prioritycritical', 'icon', 'priority', 'work type status'],
		componentName: 'PriorityCriticalIcon',
		package: '@atlaskit/icon/core/priority-critical',
		categorization: 'single-purpose',
		usage: 'Reserved for critical work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	'priority-high': {
		keywords: ['priority-high', 'priorityhigh', 'icon', 'priority', 'work type status'],
		componentName: 'PriorityHighIcon',
		package: '@atlaskit/icon/core/priority-high',
		categorization: 'single-purpose',
		usage: 'Reserved for high work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	'priority-highest': {
		keywords: ['priority-highest', 'priorityhighest', 'icon', 'priority', 'work type status'],
		componentName: 'PriorityHighestIcon',
		package: '@atlaskit/icon/core/priority-highest',
		categorization: 'single-purpose',
		usage: 'Reserved for highest work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	'priority-low': {
		keywords: ['priority-low', 'prioritylow', 'icon', 'priority', 'work type status'],
		componentName: 'PriorityLowIcon',
		package: '@atlaskit/icon/core/priority-low',
		categorization: 'single-purpose',
		usage: 'Reserved for low work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	'priority-lowest': {
		keywords: ['priority-lowest', 'prioritylowest', 'icon', 'priority', 'work type status'],
		componentName: 'PriorityLowestIcon',
		package: '@atlaskit/icon/core/priority-lowest',
		categorization: 'single-purpose',
		usage: 'Reserved for lowest work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	'priority-major': {
		keywords: ['priority-major', 'prioritymajor', 'icon', 'priority', 'work type status'],
		componentName: 'PriorityMajorIcon',
		package: '@atlaskit/icon/core/priority-major',
		categorization: 'single-purpose',
		usage: 'Reserved for major work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	'priority-medium': {
		keywords: ['priority-medium', 'prioritymedium', 'icon', 'priority', 'work type status'],
		componentName: 'PriorityMediumIcon',
		package: '@atlaskit/icon/core/priority-medium',
		categorization: 'single-purpose',
		usage: 'Reserved for medium work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	'priority-minor': {
		keywords: ['priority-minor', 'priorityminor', 'icon', 'priority', 'work type status'],
		componentName: 'PriorityMinorIcon',
		package: '@atlaskit/icon/core/priority-minor',
		categorization: 'single-purpose',
		usage: 'Reserved for minor work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	'priority-trivial': {
		keywords: ['priority-trivial', 'prioritytrivial', 'icon', 'priority', 'work type status'],
		componentName: 'PriorityTrivialIcon',
		package: '@atlaskit/icon/core/priority-trivial',
		categorization: 'single-purpose',
		usage: 'Reserved for trivial work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	problem: {
		keywords: ['problem', 'icon', 'stop', 'priority', 'work type status'],
		componentName: 'ProblemIcon',
		package: '@atlaskit/icon/core/problem',
		categorization: 'single-purpose',
		usage: 'Reserved for problem work type priority.',
		team: 'Design System Team',
		status: 'published',
	},
	project: {
		keywords: ['project', 'icon', 'rocket', 'rocketship', 'spaceship'],
		componentName: 'ProjectIcon',
		package: '@atlaskit/icon/core/project',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for projects in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	'project-status': {
		keywords: ['project-status', 'projectstatus', 'icon', 'status', 'traffic lights'],
		componentName: 'ProjectStatusIcon',
		package: '@atlaskit/icon/core/project-status',
		categorization: 'single-purpose',
		usage: 'Reserved for representing project status in Atlassian Home.',
		team: 'Atlassian Home',
		status: 'published',
	},
	'projection-screen': {
		keywords: [
			'projection-screen',
			'projectionscreen',
			'icon',
			'present',
			'presentation',
			'projector screen',
			'keynote',
		],
		componentName: 'ProjectionScreenIcon',
		package: '@atlaskit/icon/core/projection-screen',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Intended usages: Presentation mode.',
		team: 'Design System Team',
		status: 'published',
	},
	'pull-request': {
		keywords: [
			'pull-request',
			'pullrequest',
			'icon',
			'git pull request',
			'bitbucket pull request',
			'jira status',
		],
		componentName: 'PullRequestIcon',
		package: '@atlaskit/icon/core/pull-request',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for pull requests.',
		team: 'Design System Team',
		status: 'published',
	},
	pulse: {
		keywords: ['pulse', 'icon', 'pulse', 'wave', 'heartbeat', 'health'],
		componentName: 'PulseIcon',
		package: '@atlaskit/icon/core/pulse',
		categorization: 'multi-purpose',
		usage: 'Single purpose - Known uses: work health in Atlassian Home.',
		team: 'Design System Team',
		status: 'published',
	},
	'question-circle': {
		keywords: [
			'question-circle',
			'questioncircle',
			'help',
			'icon',
			'help',
			'answers',
			'faq',
			'jira status',
		],
		componentName: 'QuestionCircleIcon',
		package: '@atlaskit/icon/core/question-circle',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: help, tip.',
		team: 'Design System Team',
		status: 'published',
	},
	'quotation-mark': {
		keywords: [
			'quotation-mark',
			'quotationmark',
			'icon',
			'quote',
			'testimonial',
			'blockquote',
			'jira status',
		],
		componentName: 'QuotationMarkIcon',
		package: '@atlaskit/icon/core/quotation-mark',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	'radio-checked': {
		keywords: ['radio-checked', 'radiochecked', 'icon', 'radio', 'input type', 'selected'],
		componentName: 'RadioCheckedIcon',
		package: '@atlaskit/icon/core/radio-checked',
		categorization: 'single-purpose',
		usage: 'Reserved for the selected state of radio controls.',
		team: 'Design System Team',
		status: 'published',
	},
	'radio-unchecked': {
		keywords: ['radio-unchecked', 'radiounchecked', 'icon', 'radio', 'input type', 'unselected'],
		componentName: 'RadioUncheckedIcon',
		package: '@atlaskit/icon/core/radio-unchecked',
		categorization: 'single-purpose',
		usage: 'Reserved for the unselected state of radio controls.',
		team: 'Design System Team',
		status: 'published',
	},
	redo: {
		keywords: ['redo', 'icon', 'editor', 'redo', 'backwards'],
		componentName: 'RedoIcon',
		package: '@atlaskit/icon/core/redo',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for redo in Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	refresh: {
		keywords: [
			'refresh',
			'cycle',
			'icon',
			'refresh',
			'reload',
			'update',
			'circular arrows',
			'replay',
		],
		componentName: 'RefreshIcon',
		package: '@atlaskit/icon/core/refresh',
		categorization: 'single-purpose',
		usage: 'Reserved for reloading or replaying content',
		team: 'Design System Team',
		status: 'published',
	},
	release: {
		keywords: ['release', 'icon', 'ship', 'boat'],
		componentName: 'ReleaseIcon',
		package: '@atlaskit/icon/core/release',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for releases in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	retry: {
		keywords: ['retry', 'icon', 'try again', ''],
		componentName: 'RetryIcon',
		package: '@atlaskit/icon/core/retry',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for retry.',
		team: 'Design System Team',
		status: 'published',
	},
	roadmap: {
		keywords: ['roadmap', 'icon'],
		componentName: 'RoadmapIcon',
		package: '@atlaskit/icon/core/roadmap',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for roadmaps in Jira or Trello.',
		team: 'Design System Team',
		status: 'published',
	},
	'rovo-chat': {
		keywords: ['rovo-chat', 'rovochat', 'icon', 'Rovo', 'AI', 'chat agent'],
		componentName: 'RovoChatIcon',
		package: '@atlaskit/icon/core/rovo-chat',
		categorization: 'single-purpose',
		usage: 'Reserved for branded Rovo chat experiences.',
		team: 'Central AI',
		status: 'published',
	},
	scales: {
		keywords: ['scales', 'icon', 'scales', 'rule', 'law'],
		componentName: 'ScalesIcon',
		package: '@atlaskit/icon/core/scales',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known usages: Customer rating in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	scorecard: {
		keywords: ['scorecard', 'icon', 'tick', 'check', 'circle', 'unfinished'],
		componentName: 'ScorecardIcon',
		package: '@atlaskit/icon/core/scorecard',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for Scorecard in Analytics.',
		team: 'Design System Team',
		status: 'published',
	},
	screen: {
		keywords: ['screen', 'desktop', 'computer', 'monitor', 'icon', 'display', 'monitor', 'desktop'],
		componentName: 'ScreenIcon',
		package: '@atlaskit/icon/core/screen',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: assets in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	'screen-plus': {
		keywords: ['screen-plus', 'screenplus', 'icon', 'screen', 'display', 'monitor', 'plus', 'add'],
		componentName: 'ScreenPlusIcon',
		package: '@atlaskit/icon/core/screen-plus',
		categorization: 'multi-purpose',
		usage: 'Known uses: TBC',
		team: 'Design System Team',
		status: 'published',
	},
	search: {
		keywords: ['search', 'find', 'magnify', 'icon', 'magnifying glass'],
		componentName: 'SearchIcon',
		package: '@atlaskit/icon/core/search',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for searching objects.',
		team: 'Design System Team',
		status: 'published',
	},
	send: {
		keywords: ['send', 'mail', 'icon', 'submit', 'paper airplane', 'paper aeroplane'],
		componentName: 'SendIcon',
		package: '@atlaskit/icon/core/send',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for sending messages in Rovo Chat.',
		team: 'Design System Team',
		status: 'published',
	},
	settings: {
		keywords: [
			'settings',
			'cog',
			'options',
			'configuration',
			'icon',
			'system preferences',
			'gear',
			'cog',
		],
		componentName: 'SettingsIcon',
		package: '@atlaskit/icon/core/settings',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for any object or user settings.',
		team: 'Design System Team',
		status: 'published',
	},
	shapes: {
		keywords: ['shapes', 'icon', 'objects', 'whiteboard', 'asset', 'graphic'],
		componentName: 'ShapesIcon',
		package: '@atlaskit/icon/core/shapes',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for shapes in Whiteboards.',
		team: 'Design System Team',
		status: 'published',
	},
	share: {
		keywords: ['share', 'icon', 'share', 'access'],
		componentName: 'ShareIcon',
		package: '@atlaskit/icon/core/share',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for sharing an object.',
		team: 'Design System Team',
		status: 'published',
	},
	shield: {
		keywords: ['shield', 'icon', 'security', 'secure', 'safety', 'defence', 'protection', 'guard'],
		componentName: 'ShieldIcon',
		package: '@atlaskit/icon/core/shield',
		categorization: 'multi-purpose',
		usage:
			'Multi purpose - Known uses: classifications in Enterprise Trust, security in Jira (Spork)',
		team: 'Design System Team',
		status: 'published',
	},
	'shield-strikethrough': {
		keywords: [
			'shield-strikethrough',
			'shieldstrikethrough',
			'icon',
			'️security',
			'secure',
			'safety',
			'defence',
			'protection',
			'guard',
			'strikethrough',
			'classification',
		],
		componentName: 'ShieldStrikethroughIcon',
		package: '@atlaskit/icon/core/shield-strikethrough',
		categorization: 'multi-purpose',
		usage: 'Known uses: No classification in Enterprise Trust',
		team: 'Enterprise Trust',
		status: 'published',
	},
	shortcut: {
		keywords: ['shortcut', 'export', 'icon', 'addshortcut', 'square', 'plus'],
		componentName: 'ShortcutIcon',
		package: '@atlaskit/icon/core/shortcut',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for shortcuts in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	'show-more-horizontal': {
		keywords: [
			'show-more-horizontal',
			'showmorehorizontal',
			'icon',
			'ellipses',
			'three dots',
			'meatball',
			'more actions',
		],
		componentName: 'ShowMoreHorizontalIcon',
		package: '@atlaskit/icon/core/show-more-horizontal',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for more action menus.',
		team: 'Design System Team',
		status: 'published',
	},
	'show-more-vertical': {
		keywords: [
			'show-more-vertical',
			'showmorevertical',
			'icon',
			'three dots',
			'kebab',
			'more actions',
		],
		componentName: 'ShowMoreVerticalIcon',
		package: '@atlaskit/icon/core/show-more-vertical',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for more action menus, traditionally on mobile.',
		team: 'Design System Team',
		status: 'published',
	},
	'shrink-diagonal': {
		keywords: ['shrink-diagonal', 'shrinkdiagonal', 'icon', 'resize', 'diagonal arrows'],
		componentName: 'ShrinkDiagonalIcon',
		package: '@atlaskit/icon/core/shrink-diagonal',
		categorization: 'single-purpose',
		usage:
			'Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.',
		team: 'Design System Team',
		status: 'published',
	},
	'shrink-horizontal': {
		keywords: [
			'shrink-horizontal',
			'shrinkhorizontal',
			'icon',
			'contract',
			'width',
			'horizontal arrows',
		],
		componentName: 'ShrinkHorizontalIcon',
		package: '@atlaskit/icon/core/shrink-horizontal',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for contracting or reducing the width of an element.',
		team: 'Design System Team',
		status: 'published',
	},
	'shrink-vertical': {
		keywords: [
			'shrink-vertical',
			'shrinkvertical',
			'icon',
			'contract',
			'height',
			'vertical arrows',
		],
		componentName: 'ShrinkVerticalIcon',
		package: '@atlaskit/icon/core/shrink-vertical',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for contracting or reducing the height of an element.',
		team: 'Design System Team',
		status: 'published',
	},
	'sidebar-collapse': {
		keywords: ['sidebar-collapse', 'sidebarcollapse', 'icon', 'navigation', 'close sidebar'],
		componentName: 'SidebarCollapseIcon',
		package: '@atlaskit/icon/core/sidebar-collapse',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for collapsing the navigation sidebar.',
		team: 'Design System Team',
		status: 'published',
	},
	'sidebar-expand': {
		keywords: ['sidebar-expand', 'sidebarexpand', 'icon', 'navigation', 'open sidebar'],
		componentName: 'SidebarExpandIcon',
		package: '@atlaskit/icon/core/sidebar-expand',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for expanding the navigation sidebar.',
		team: 'Design System Team',
		status: 'published',
	},
	'smart-link': {
		keywords: ['smart-link', 'smartlink', 'icon', 'smart link'],
		componentName: 'SmartLinkIcon',
		package: '@atlaskit/icon/core/smart-link',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Smart links.',
		team: 'Linking platform',
		status: 'published',
	},
	'smart-link-card': {
		keywords: [
			'smart-link-card',
			'smartlinkcard',
			'icon',
			'smart link',
			'url',
			'card',
			'link preview',
		],
		componentName: 'SmartLinkCardIcon',
		package: '@atlaskit/icon/core/smart-link-card',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Smart link preview cards.',
		team: 'Linking platform',
		status: 'published',
	},
	'smart-link-embed': {
		keywords: ['smart-link-embed', 'smartlinkembed', 'icon', 'smart link', 'url', 'embed'],
		componentName: 'SmartLinkEmbedIcon',
		package: '@atlaskit/icon/core/smart-link-embed',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Smart link embeds.',
		team: 'Linking platform',
		status: 'published',
	},
	'smart-link-inline': {
		keywords: ['smart-link-inline', 'smartlinkinline', 'icon', 'smart link', 'url', 'inline'],
		componentName: 'SmartLinkInlineIcon',
		package: '@atlaskit/icon/core/smart-link-inline',
		categorization: 'single-purpose',
		usage: 'Reserved for representing inline Smart link lozenges.',
		team: 'Linking platform',
		status: 'published',
	},
	'smart-link-list': {
		keywords: [
			'smart-link-list',
			'smartlinklist',
			'icon',
			'smart link',
			'url',
			'embed',
			'list',
			'table',
			'linked search results',
		],
		componentName: 'SmartLinkListIcon',
		package: '@atlaskit/icon/core/smart-link-list',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Smart link embedded link lists.',
		team: 'Linking platform',
		status: 'published',
	},
	snippet: {
		keywords: ['snippet', 'icon', 'scissors', 'cut'],
		componentName: 'SnippetIcon',
		package: '@atlaskit/icon/core/snippet',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for snippets in Bitbucket.',
		team: 'Design System Team',
		status: 'published',
	},
	'sort-ascending': {
		keywords: ['sort-ascending', 'sortascending', 'icon', 'data', 'sort', 'up'],
		componentName: 'SortAscendingIcon',
		package: '@atlaskit/icon/core/sort-ascending',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for sorting data.',
		team: 'Design System Team',
		status: 'published',
	},
	'sort-descending': {
		keywords: ['sort-descending', 'sortdescending', 'icon', 'data', 'sort', 'down'],
		componentName: 'SortDescendingIcon',
		package: '@atlaskit/icon/core/sort-descending',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for sorting data.',
		team: 'Design System Team',
		status: 'published',
	},
	spreadsheet: {
		keywords: [
			'spreadsheet',
			'icon',
			'table',
			'cells',
			'tabular data',
			'data table',
			'spreadsheet',
		],
		componentName: 'SpreadsheetIcon',
		package: '@atlaskit/icon/core/spreadsheet',
		replacement: { name: 'table', location: '@atlaskit/icon' },
		categorization: 'single-purpose',
		usage: 'Reserved for tables, tabular data, and spreadsheets.',
		team: 'Design System Team',
		status: 'deprecated',
	},
	sprint: {
		keywords: ['sprint', 'icon', 'loop', 'iterate'],
		componentName: 'SprintIcon',
		package: '@atlaskit/icon/core/sprint',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for sprints in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	'star-starred': {
		keywords: ['star-starred', 'starstarred', 'icon', 'favourite', 'star', 'starred', 'filled'],
		componentName: 'StarStarredIcon',
		package: '@atlaskit/icon/core/star-starred',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for starred or favourited objects.',
		team: 'Design System Team',
		status: 'published',
	},
	'star-unstarred': {
		keywords: ['star-unstarred', 'starunstarred', 'icon', 'favourite', 'star'],
		componentName: 'StarUnstarredIcon',
		package: '@atlaskit/icon/core/star-unstarred',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for starring or favoriting objects.',
		team: 'Design System Team',
		status: 'published',
	},
	'status-discovery': {
		keywords: [
			'status-discovery',
			'statusdiscovery',
			'icon',
			'discovery',
			'note',
			'filled',
			'onboarding',
			'status',
		],
		componentName: 'StatusDiscoveryIcon',
		package: '@atlaskit/icon/core/status-discovery',
		categorization: 'single-purpose',
		usage:
			'Reserved for discovery statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.',
		team: 'Design System Team',
		status: 'published',
	},
	'status-error': {
		keywords: [
			'status-error',
			'statuserror',
			'icon',
			'filled',
			'status',
			'danger',
			'exclamation',
			'!',
			'error',
		],
		componentName: 'StatusErrorIcon',
		package: '@atlaskit/icon/core/status-error',
		categorization: 'single-purpose',
		usage:
			'Reserved for error statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.',
		team: 'Design System Team',
		status: 'published',
	},
	'status-information': {
		keywords: [
			'status-information',
			'statusinformation',
			'icon',
			'info',
			'filled',
			'status',
			'information',
		],
		componentName: 'StatusInformationIcon',
		package: '@atlaskit/icon/core/status-information',
		categorization: 'single-purpose',
		usage:
			"Reserved for information statuses and messaging.  Filled status icons provide higher visual contrast to draw attention to important information. For information tooltips, use the unfilled \'information circle\' icon.",
		team: 'Design System Team',
		status: 'published',
	},
	'status-success': {
		keywords: [
			'status-success',
			'statussuccess',
			'icon',
			'tick',
			'completed',
			'success',
			'filled',
			'check mark',
			'status',
		],
		componentName: 'StatusSuccessIcon',
		package: '@atlaskit/icon/core/status-success',
		categorization: 'single-purpose',
		usage:
			'Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.',
		team: 'Design System Team',
		status: 'published',
	},
	'status-verified': {
		keywords: ['status-verified', 'statusverified', 'icon', 'verified badge', 'status'],
		componentName: 'StatusVerifiedIcon',
		package: '@atlaskit/icon/core/status-verified',
		categorization: 'single-purpose',
		usage:
			'Reserved for representing verified content. Filled status icons provide higher visual contrast draw attention to important information.',
		team: 'Design System Team',
		status: 'published',
	},
	'status-warning': {
		keywords: [
			'status-warning',
			'statuswarning',
			'icon',
			'alert',
			'filled',
			'exclamation',
			'!',
			'warning',
			'status',
		],
		componentName: 'StatusWarningIcon',
		package: '@atlaskit/icon/core/status-warning',
		categorization: 'single-purpose',
		usage:
			'Reserved for warning statuses. Filled status icons provide higher visual contrast to draw attention to important information.',
		team: 'Design System Team',
		status: 'published',
	},
	stopwatch: {
		keywords: ['stopwatch', 'icon', 'timer'],
		componentName: 'StopwatchIcon',
		package: '@atlaskit/icon/core/stopwatch',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: timer in Confluence Whiteboards.',
		team: 'Design System Team',
		status: 'published',
	},
	story: {
		keywords: ['story', 'icon', 'bookmark', 'work type'],
		componentName: 'StoryIcon',
		package: '@atlaskit/icon/core/story',
		categorization: 'single-purpose',
		usage: 'Reserved for story work type.',
		team: 'Design System Team',
		status: 'published',
	},
	'stroke-weight-extra-large': {
		keywords: [
			'stroke-weight-extra-large',
			'strokeweightextralarge',
			'icon',
			'border',
			'weight',
			'thickness',
			'stroke',
			'confluence',
			'editor',
			'whiteboards',
			'thickest',
		],
		componentName: 'StrokeWeightExtraLargeIcon',
		package: '@atlaskit/icon/core/stroke-weight-extra-large',
		categorization: 'single-purpose',
		usage: 'Reserved for representing the thickest border stroke width.',
		team: 'Whiteboards',
		status: 'published',
	},
	'stroke-weight-large': {
		keywords: [
			'stroke-weight-large',
			'strokeweightlarge',
			'icon',
			'border',
			'weight',
			'thickness',
			'stroke',
			'thick',
			'confluence',
			'editor',
			'whiteboards',
		],
		componentName: 'StrokeWeightLargeIcon',
		package: '@atlaskit/icon/core/stroke-weight-large',
		categorization: 'single-purpose',
		usage: 'Reserved for representing thick border stroke widths.',
		team: 'Editor',
		status: 'published',
	},
	'stroke-weight-medium': {
		keywords: [
			'stroke-weight-medium',
			'strokeweightmedium',
			'icon',
			'border',
			'weight',
			'stroke',
			'medium',
			'thickness',
			'confluence',
			'editor',
			'whiteboards',
		],
		componentName: 'StrokeWeightMediumIcon',
		package: '@atlaskit/icon/core/stroke-weight-medium',
		categorization: 'single-purpose',
		usage: 'Reserved for representing medium border stroke widths.',
		team: 'Editor',
		status: 'published',
	},
	'stroke-weight-small': {
		keywords: [
			'stroke-weight-small',
			'strokeweightsmall',
			'icon',
			'border',
			'weight',
			'thickness',
			'stroke',
			'confluence',
			'editor',
			'whiteboards',
			'thin',
		],
		componentName: 'StrokeWeightSmallIcon',
		package: '@atlaskit/icon/core/stroke-weight-small',
		categorization: 'single-purpose',
		usage: 'Reserved for representing thin border stroke widths.',
		team: 'Editor',
		status: 'published',
	},
	subtasks: {
		keywords: ['subtasks', 'icon', 'todo', 'checklist', 'work type'],
		componentName: 'SubtasksIcon',
		package: '@atlaskit/icon/core/subtasks',
		categorization: 'single-purpose',
		usage: 'Reserved for subtask work type.',
		team: 'Design System Team',
		status: 'published',
	},
	success: {
		keywords: ['success', 'icon', 'tick', 'completed', 'success', 'filled', 'check mark', 'status'],
		componentName: 'SuccessIcon',
		package: '@atlaskit/icon/core/success',
		replacement: { name: 'status-success', location: '@atlaskit/icon' },
		categorization: 'single-purpose',
		usage:
			'Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.',
		team: 'Design System Team',
		status: 'deprecated',
	},
	support: {
		keywords: [
			'support',
			'icon',
			'support',
			'help',
			'life raft',
			'life ring',
			'lifebuoy',
			'life preserver',
		],
		componentName: 'SupportIcon',
		package: '@atlaskit/icon/core/support',
		categorization: 'single-purpose',
		usage: 'Reserved for representing help support.',
		team: 'Design System Team',
		status: 'published',
	},
	table: {
		keywords: [
			'table',
			'grid',
			'icon',
			'table',
			'cells',
			'tabular data',
			'data table',
			'spreadsheet',
		],
		componentName: 'TableIcon',
		package: '@atlaskit/icon/core/table',
		categorization: 'single-purpose',
		usage: 'Reserved for tables, tabular data, and spreadsheets.',
		team: 'Design System Team',
		status: 'published',
	},
	'table-cell-clear': {
		keywords: ['table-cell-clear', 'tablecellclear', 'icon', 'table', 'cell', 'clear', 'empty'],
		componentName: 'TableCellClearIcon',
		package: '@atlaskit/icon/core/table-cell-clear',
		categorization: 'single-purpose',
		usage: 'Reserved for clearing the contents of table cells.',
		team: 'Editor',
		status: 'published',
	},
	'table-cell-merge': {
		keywords: [
			'table-cell-merge',
			'tablecellmerge',
			'icon',
			'table',
			'cell',
			'merge',
			'combine',
			'join',
		],
		componentName: 'TableCellMergeIcon',
		package: '@atlaskit/icon/core/table-cell-merge',
		categorization: 'single-purpose',
		usage: 'Reserved for merging table cells.',
		team: 'Editor',
		status: 'published',
	},
	'table-cell-split': {
		keywords: [
			'table-cell-split',
			'tablecellsplit',
			'icon',
			'table',
			'cell',
			'split',
			'divide',
			'separate',
		],
		componentName: 'TableCellSplitIcon',
		package: '@atlaskit/icon/core/table-cell-split',
		categorization: 'single-purpose',
		usage: 'Reserved for splitting joined table cells.',
		team: 'Editor',
		status: 'published',
	},
	'table-column-add-left': {
		keywords: [
			'table-column-add-left',
			'tablecolumnaddleft',
			'icon',
			'table',
			'column',
			'add',
			'plus',
			'left',
			'before',
		],
		componentName: 'TableColumnAddLeftIcon',
		package: '@atlaskit/icon/core/table-column-add-left',
		categorization: 'single-purpose',
		usage: 'Reserved for adding a table column to the left of the selected column.',
		team: 'Editor',
		status: 'published',
	},
	'table-column-add-right': {
		keywords: [
			'table-column-add-right',
			'tablecolumnaddright',
			'icon',
			'table',
			'column',
			'add',
			'right',
			'after',
		],
		componentName: 'TableColumnAddRightIcon',
		package: '@atlaskit/icon/core/table-column-add-right',
		categorization: 'single-purpose',
		usage: 'Reserved for adding a table column to the right of the selected column.',
		team: 'Editor',
		status: 'published',
	},
	'table-column-delete': {
		keywords: [
			'table-column-delete',
			'tablecolumndelete',
			'icon',
			'table',
			'column',
			'delete',
			'remove',
			'x',
		],
		componentName: 'TableColumnDeleteIcon',
		package: '@atlaskit/icon/core/table-column-delete',
		categorization: 'single-purpose',
		usage: 'Reserved for deleting a table column.',
		team: 'Editor',
		status: 'published',
	},
	'table-column-move-left': {
		keywords: [
			'table-column-move-left',
			'tablecolumnmoveleft',
			'icon',
			'table',
			'column',
			'move',
			'left',
			'arrow',
		],
		componentName: 'TableColumnMoveLeftIcon',
		package: '@atlaskit/icon/core/table-column-move-left',
		categorization: 'single-purpose',
		usage: 'Reserved for moving a table column to the left of its current location.',
		team: 'Editor',
		status: 'published',
	},
	'table-column-move-right': {
		keywords: [
			'table-column-move-right',
			'tablecolumnmoveright',
			'icon',
			'table',
			'column',
			'move',
			'right',
			'arrow',
		],
		componentName: 'TableColumnMoveRightIcon',
		package: '@atlaskit/icon/core/table-column-move-right',
		categorization: 'single-purpose',
		usage: 'Reserved for moving a table column to the right of its current location.',
		team: 'Editor',
		status: 'published',
	},
	'table-columns-distribute': {
		keywords: [
			'table-columns-distribute',
			'tablecolumnsdistribute',
			'icon',
			'table',
			'columns',
			'distribute',
			'even',
			'equidistant',
		],
		componentName: 'TableColumnsDistributeIcon',
		package: '@atlaskit/icon/core/table-columns-distribute',
		categorization: 'single-purpose',
		usage: 'Reserved for distributing the width of table columns evenly.',
		team: 'Editor',
		status: 'published',
	},
	'table-row-add-above': {
		keywords: [
			'table-row-add-above',
			'tablerowaddabove',
			'icon',
			'table',
			'row',
			'add',
			'plus',
			'above',
			'up',
		],
		componentName: 'TableRowAddAboveIcon',
		package: '@atlaskit/icon/core/table-row-add-above',
		categorization: 'single-purpose',
		usage: 'Reserved for adding a table row above the selected row.',
		team: 'Editor',
		status: 'published',
	},
	'table-row-add-below': {
		keywords: [
			'table-row-add-below',
			'tablerowaddbelow',
			'icon',
			'table',
			'row',
			'add',
			'plus',
			'below',
			'down',
		],
		componentName: 'TableRowAddBelowIcon',
		package: '@atlaskit/icon/core/table-row-add-below',
		categorization: 'single-purpose',
		usage: 'Reserved for adding a table row below the selected row.',
		team: 'Editor',
		status: 'published',
	},
	'table-row-delete': {
		keywords: [
			'table-row-delete',
			'tablerowdelete',
			'icon',
			'table',
			'row',
			'delete',
			'remove',
			'x',
		],
		componentName: 'TableRowDeleteIcon',
		package: '@atlaskit/icon/core/table-row-delete',
		categorization: 'single-purpose',
		usage: 'Reserved for deleting a table row.',
		team: 'Editor',
		status: 'published',
	},
	'table-row-move-down': {
		keywords: [
			'table-row-move-down',
			'tablerowmovedown',
			'icon',
			'table',
			'row',
			'move',
			'down',
			'arrow',
			'after',
		],
		componentName: 'TableRowMoveDownIcon',
		package: '@atlaskit/icon/core/table-row-move-down',
		categorization: 'single-purpose',
		usage: 'Reserved for moving a table row below its current location.',
		team: 'Editor',
		status: 'published',
	},
	'table-row-move-up': {
		keywords: [
			'table-row-move-up',
			'tablerowmoveup',
			'icon',
			'table',
			'row',
			'move',
			'up',
			'arrow',
			'above',
		],
		componentName: 'TableRowMoveUpIcon',
		package: '@atlaskit/icon/core/table-row-move-up',
		categorization: 'single-purpose',
		usage: 'Reserved for moving a table row above its current location.',
		team: 'Editor',
		status: 'published',
	},
	tag: {
		keywords: ['tag', 'icon', 'label', 'topic'],
		componentName: 'TagIcon',
		package: '@atlaskit/icon/core/tag',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for tags in Atlas.',
		team: 'Design System Team',
		status: 'published',
	},
	'takeout-food': {
		keywords: [
			'takeout-food',
			'takeoutfood',
			'icon',
			'takeaway',
			'takeout',
			'food',
			'burger',
			'drink',
		],
		componentName: 'TakeoutFoodIcon',
		package: '@atlaskit/icon/core/takeout-food',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known usages: Food emoji category.',
		team: 'Design System Team',
		status: 'published',
	},
	target: {
		keywords: ['target', 'icon', 'target', 'bullseye'],
		componentName: 'TargetIcon',
		package: '@atlaskit/icon/core/target',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for targets.',
		team: 'Design System Team',
		status: 'published',
	},
	task: {
		keywords: [
			'task',
			'check',
			'tick',
			'icon',
			'single task',
			'todo',
			'list',
			'check mark',
			'tick',
		],
		componentName: 'TaskIcon',
		package: '@atlaskit/icon/core/task',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for tasks in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	'task-in-progress': {
		keywords: [
			'task-in-progress',
			'taskinprogress',
			'icon',
			'calendar',
			'task',
			'status',
			'in progress',
		],
		componentName: 'TaskInProgressIcon',
		package: '@atlaskit/icon/core/task-in-progress',
		categorization: 'single-purpose',
		usage: 'Reserved for in progress task status. Used in JSM Calendar view.',
		team: 'JSM Calendar',
		status: 'published',
	},
	'task-to-do': {
		keywords: ['task-to-do', 'tasktodo', 'icon', 'calendar', 'task', 'to-do', 'todo', 'status'],
		componentName: 'TaskToDoIcon',
		package: '@atlaskit/icon/core/task-to-do',
		categorization: 'single-purpose',
		usage: 'Reserved for to-do task status. Used in JSM Calendar view.',
		team: 'JSM Calendar',
		status: 'published',
	},
	tasks: {
		keywords: ['tasks', 'icon', 'multiple tasks', 'todo', 'list', 'check mark', 'tick'],
		componentName: 'TasksIcon',
		package: '@atlaskit/icon/core/tasks',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for multiple tasks in Jira.',
		team: 'Design System Team',
		status: 'published',
	},
	teams: {
		keywords: ['teams', 'icon', 'infinite love', 'people', 'persons', 'customers', 'users'],
		componentName: 'TeamsIcon',
		package: '@atlaskit/icon/core/teams',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for teams in Atlassian.',
		team: 'Design System Team',
		status: 'published',
	},
	text: {
		keywords: ['text', 'icon', 'character', 'font', 'letter', 'type', 'typography', 'text'],
		componentName: 'TextIcon',
		package: '@atlaskit/icon/core/text',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for representing text objects.',
		team: 'Design System Team',
		status: 'published',
	},
	'text-bold': {
		keywords: ['text-bold', 'textbold', 'icon', 'text', 'type', 'bold', 'font'],
		componentName: 'TextBoldIcon',
		package: '@atlaskit/icon/core/text-bold',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for bolding text.',
		team: 'Design System Team',
		status: 'published',
	},
	'text-heading': {
		keywords: [
			'text-heading',
			'textheading',
			'icon',
			'text',
			'heading',
			'H',
			'editor',
			'text style',
		],
		componentName: 'TextHeadingIcon',
		package: '@atlaskit/icon/core/text-heading',
		categorization: 'single-purpose',
		usage: 'Reserved for representing heading styles',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'text-indent-left': {
		keywords: ['text-indent-left', 'textindentleft', 'icon', 'text', 'outdent', 'left', 'arrow'],
		componentName: 'TextIndentLeftIcon',
		package: '@atlaskit/icon/core/text-indent-left',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for shifting the indent of text content left.',
		team: 'Design System Team',
		status: 'published',
	},
	'text-indent-right': {
		keywords: ['text-indent-right', 'textindentright', 'icon', 'text', 'indent', 'right', 'arrow'],
		componentName: 'TextIndentRightIcon',
		package: '@atlaskit/icon/core/text-indent-right',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for shifting the indent of text content right.',
		team: 'Design System Team',
		status: 'published',
	},
	'text-italic': {
		keywords: ['text-italic', 'textitalic', 'icon', 'text', 'type', 'italic', 'font'],
		componentName: 'TextItalicIcon',
		package: '@atlaskit/icon/core/text-italic',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for italicizing text.',
		team: 'Design System Team',
		status: 'published',
	},
	'text-shorten': {
		keywords: [
			'text-shorten',
			'textshorten',
			'icon',
			'text',
			'shorten',
			'abbreviate',
			'condense',
			'AI',
		],
		componentName: 'TextShortenIcon',
		package: '@atlaskit/icon/core/text-shorten',
		categorization: 'single-purpose',
		usage: 'Reserved for shortening text content with Atlassian Intelligence.',
		team: 'Atlassian Intelligence',
		status: 'published',
	},
	'text-spellcheck': {
		keywords: [
			'text-spellcheck',
			'textspellcheck',
			'icon',
			'text',
			'spelling',
			'typo',
			'spellcheck',
		],
		componentName: 'TextSpellcheckIcon',
		package: '@atlaskit/icon/core/text-spellcheck',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for spellchecking.',
		team: 'Design System Team',
		status: 'published',
	},
	'text-strikethrough': {
		keywords: [
			'text-strikethrough',
			'textstrikethrough',
			'icon',
			'text',
			'strikethrough',
			'editor',
			'cross out',
		],
		componentName: 'TextStrikethroughIcon',
		package: '@atlaskit/icon/core/text-strikethrough',
		categorization: 'single-purpose',
		usage: 'Reserved for strikethrough text tool',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'text-style': {
		keywords: [
			'text-style',
			'textstyle',
			'icon',
			'characters',
			'font',
			'letters',
			'type',
			'typography',
		],
		componentName: 'TextStyleIcon',
		package: '@atlaskit/icon/core/text-style',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for text styles in Editor.',
		team: 'Editor',
		status: 'published',
	},
	'text-underline': {
		keywords: ['text-underline', 'textunderline', 'icon', 'text', 'underline', 'U', 'editor'],
		componentName: 'TextUnderlineIcon',
		package: '@atlaskit/icon/core/text-underline',
		categorization: 'single-purpose',
		usage: 'Reserved for underlined text tool',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'text-wrap': {
		keywords: ['text-wrap', 'textwrap', 'icon', 'text', 'wrap', 'line wrap'],
		componentName: 'TextWrapIcon',
		package: '@atlaskit/icon/core/text-wrap',
		categorization: 'single-purpose',
		usage: 'Reserved for wrapping text so it spans multiple lines.',
		team: 'Design System Team',
		status: 'published',
	},
	theme: {
		keywords: ['theme', 'icon', 'theme', 'light mode', 'dark mode', 'theme switcher'],
		componentName: 'ThemeIcon',
		package: '@atlaskit/icon/core/theme',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for representing themes and theme switching.',
		team: 'Design System Team',
		status: 'published',
	},
	'thumbs-down': {
		keywords: [
			'thumbs-down',
			'thumbsdown',
			'icon',
			'vote',
			'downvote',
			'dislike',
			'feedback',
			'hand',
		],
		componentName: 'ThumbsDownIcon',
		package: '@atlaskit/icon/core/thumbs-down',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: voting, feedback in AI.',
		team: 'Design System Team',
		status: 'published',
	},
	'thumbs-up': {
		keywords: ['thumbs-up', 'thumbsup', 'icon', 'vote', 'upvote', 'like', 'feedback', 'hand'],
		componentName: 'ThumbsUpIcon',
		package: '@atlaskit/icon/core/thumbs-up',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known uses: voting options in Jira, like.',
		team: 'Design System Team',
		status: 'published',
	},
	timeline: {
		keywords: ['timeline', 'icon', 'gantt', 'calendar'],
		componentName: 'TimelineIcon',
		package: '@atlaskit/icon/core/timeline',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for timelines in Jira or Trello.',
		team: 'Design System Team',
		status: 'published',
	},
	tools: {
		keywords: ['tools', 'icon', 'tools', 'wrench', 'spanner', 'screwdriver'],
		componentName: 'ToolsIcon',
		package: '@atlaskit/icon/core/tools',
		categorization: 'multi-purpose',
		usage: "Known usages: \'Service request\' Jira work type.",
		team: 'Design System Team',
		status: 'published',
	},
	transition: {
		keywords: ['transition', 'icon', 'connector', 'movement'],
		componentName: 'TransitionIcon',
		package: '@atlaskit/icon/core/transition',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for transitions in Analytics.',
		team: 'Design System Team',
		status: 'published',
	},
	translate: {
		keywords: [
			'translate',
			'icon',
			'translate',
			'language',
			'i18n',
			'internationalization',
			'internationalisation',
		],
		componentName: 'TranslateIcon',
		package: '@atlaskit/icon/core/translate',
		categorization: 'single-purpose',
		usage: 'Reserved for representing language translations.',
		team: 'Design System Team',
		status: 'published',
	},
	tree: {
		keywords: ['tree', 'icon', 'tree', 'nature'],
		componentName: 'TreeIcon',
		package: '@atlaskit/icon/core/tree',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known usages: Nature emoji category.',
		team: 'Design System Team',
		status: 'published',
	},
	undo: {
		keywords: ['undo', 'icon', 'backward', 'mistake', 'correct'],
		componentName: 'UndoIcon',
		package: '@atlaskit/icon/core/undo',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for undo in Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	upload: {
		keywords: ['upload', 'cloud', 'icon', 'stream', 'file'],
		componentName: 'UploadIcon',
		package: '@atlaskit/icon/core/upload',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for upload in Editor.',
		team: 'Design System Team',
		status: 'published',
	},
	'vehicle-car': {
		keywords: ['vehicle-car', 'vehiclecar', 'icon', 'car', 'transportation', 'vehicle'],
		componentName: 'VehicleCarIcon',
		package: '@atlaskit/icon/core/vehicle-car',
		categorization: 'multi-purpose',
		usage: 'Multi purpose - Known usages: Transport emoji category.',
		team: 'Design System Team',
		status: 'published',
	},
	video: {
		keywords: ['video', 'icon', 'media', 'movie'],
		componentName: 'VideoIcon',
		package: '@atlaskit/icon/core/video',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for representing video content across Atlassian and Loom.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-next': {
		keywords: ['video-next', 'videonext', 'icon', 'skip', 'next', 'media', 'forward'],
		componentName: 'VideoNextIcon',
		package: '@atlaskit/icon/core/video-next',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for next video in Media.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-next-overlay': {
		keywords: [
			'video-next-overlay',
			'videonextoverlay',
			'icon',
			'skip',
			'next',
			'media',
			'forward',
			'filled',
		],
		componentName: 'VideoNextOverlayIcon',
		package: '@atlaskit/icon/core/video-next-overlay',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for next video when icon is overlayed on Media.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-pause': {
		keywords: ['video-pause', 'videopause', 'icon', 'media', 'video'],
		componentName: 'VideoPauseIcon',
		package: '@atlaskit/icon/core/video-pause',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for pause video in Media.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-pause-overlay': {
		keywords: ['video-pause-overlay', 'videopauseoverlay', 'icon', 'media', 'video', 'filled'],
		componentName: 'VideoPauseOverlayIcon',
		package: '@atlaskit/icon/core/video-pause-overlay',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for pause video when icon is overlayed on Media.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-play': {
		keywords: ['video-play', 'videoplay', 'icon', 'media', 'video'],
		componentName: 'VideoPlayIcon',
		package: '@atlaskit/icon/core/video-play',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for play video in Media.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-play-overlay': {
		keywords: ['video-play-overlay', 'videoplayoverlay', 'icon', 'media', 'video', 'filled'],
		componentName: 'VideoPlayOverlayIcon',
		package: '@atlaskit/icon/core/video-play-overlay',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for play video when icon is overlayed on Media.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-previous': {
		keywords: ['video-previous', 'videoprevious', 'icon', 'media', 'video', 'back', 'previous'],
		componentName: 'VideoPreviousIcon',
		package: '@atlaskit/icon/core/video-previous',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for previous video in Media.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-previous-overlay': {
		keywords: [
			'video-previous-overlay',
			'videopreviousoverlay',
			'icon',
			'media',
			'video',
			'back',
			'previous',
			'filled',
		],
		componentName: 'VideoPreviousOverlayIcon',
		package: '@atlaskit/icon/core/video-previous-overlay',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for previous video when icon is overlayed on Media.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-skip-backward-fifteen': {
		keywords: [
			'video-skip-backward-fifteen',
			'videoskipbackwardfifteen',
			'icon',
			'video',
			'media',
			'skip',
			'backwards',
			'15',
			'seconds',
		],
		componentName: 'VideoSkipBackwardFifteenIcon',
		package: '@atlaskit/icon/core/video-skip-backward-fifteen',
		categorization: 'single-purpose',
		usage: 'Reserved for skipping video content backward by 15 seconds.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-skip-backward-ten': {
		keywords: [
			'video-skip-backward-ten',
			'videoskipbackwardten',
			'icon',
			'video',
			'media',
			'skip',
			'backwards',
			'10',
			'seconds',
		],
		componentName: 'VideoSkipBackwardTenIcon',
		package: '@atlaskit/icon/core/video-skip-backward-ten',
		categorization: 'single-purpose',
		usage: 'Reserved for skipping video content backwards by 10 seconds.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-skip-forward-fifteen': {
		keywords: [
			'video-skip-forward-fifteen',
			'videoskipforwardfifteen',
			'icon',
			'video',
			'media',
			'skip',
			'forward',
			'15',
			'seconds',
		],
		componentName: 'VideoSkipForwardFifteenIcon',
		package: '@atlaskit/icon/core/video-skip-forward-fifteen',
		categorization: 'single-purpose',
		usage: 'Reserved for skipping video content forward by 15 seconds.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-skip-forward-ten': {
		keywords: [
			'video-skip-forward-ten',
			'videoskipforwardten',
			'icon',
			'video',
			'media',
			'skip',
			'forward',
			'10',
			'seconds',
		],
		componentName: 'VideoSkipForwardTenIcon',
		package: '@atlaskit/icon/core/video-skip-forward-ten',
		categorization: 'single-purpose',
		usage: 'Reserved for skipping video content forward by 10 seconds.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-stop': {
		keywords: ['video-stop', 'videostop', 'icon', 'video', 'stop'],
		componentName: 'VideoStopIcon',
		package: '@atlaskit/icon/core/video-stop',
		categorization: 'single-purpose',
		usage: 'Reserved for stopping video content.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-stop-overlay': {
		keywords: [
			'video-stop-overlay',
			'videostopoverlay',
			'icon',
			'video',
			'stop',
			'overlay',
			'inverse',
		],
		componentName: 'VideoStopOverlayIcon',
		package: '@atlaskit/icon/core/video-stop-overlay',
		categorization: 'single-purpose',
		usage: 'Reserved for stopping video content. Use on dark or translucent backgrounds.',
		team: 'Design System Team',
		status: 'published',
	},
	'volume-high': {
		keywords: ['volume-high', 'volumehigh', 'icon', 'louder', 'volume up'],
		componentName: 'VolumeHighIcon',
		package: '@atlaskit/icon/core/volume-high',
		categorization: 'multi-purpose',
		usage: '📦 @atlaskit/icon/core/volume-high',
		team: 'Design System Team',
		status: 'published',
	},
	'volume-low': {
		keywords: ['volume-low', 'volumelow', 'icon', 'quiter', 'volume down'],
		componentName: 'VolumeLowIcon',
		package: '@atlaskit/icon/core/volume-low',
		categorization: 'multi-purpose',
		usage: '📦 @atlaskit/icon/core/volume-low',
		team: 'Design System Team',
		status: 'published',
	},
	'volume-muted': {
		keywords: ['volume-muted', 'volumemuted', 'icon', 'volume off', 'no volume'],
		componentName: 'VolumeMutedIcon',
		package: '@atlaskit/icon/core/volume-muted',
		categorization: 'multi-purpose',
		usage: '📦 @atlaskit/icon/core/volume-muted',
		team: 'Design System Team',
		status: 'published',
	},
	warning: {
		keywords: [
			'warning',
			'error',
			'alert',
			'icon',
			'alert',
			'filled',
			'exclamation',
			'!',
			'warning',
			'status',
		],
		componentName: 'WarningIcon',
		package: '@atlaskit/icon/core/warning',
		replacement: { name: 'status-warning', location: '@atlaskit/icon' },
		categorization: 'single-purpose',
		usage:
			'Reserved for warning statuses. Filled status icons provide higher visual contrast to draw attention to important information.',
		team: 'Design System Team',
		status: 'deprecated',
	},
	whiteboard: {
		keywords: ['whiteboard', 'icon', 'shapes', 'canvas'],
		componentName: 'WhiteboardIcon',
		package: '@atlaskit/icon/core/whiteboard',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for whiteboards in Confluence.',
		team: 'Design System Team',
		status: 'published',
	},
	'work-item': {
		keywords: ['work-item', 'workitem', 'icon', 'check mark', 'tick', 'work item', 'work type'],
		componentName: 'WorkItemIcon',
		package: '@atlaskit/icon/core/work-item',
		categorization: 'single-purpose',
		usage: 'Reserved for work items.',
		team: 'Design System Team',
		status: 'published',
	},
	'work-items': {
		keywords: ['work-items', 'workitems', 'icon', 'check mark', 'tick', 'work items', 'work type'],
		componentName: 'WorkItemsIcon',
		package: '@atlaskit/icon/core/work-items',
		categorization: 'single-purpose',
		usage: 'Reserved for representing multiple work items.',
		team: 'Design System Team',
		status: 'published',
	},
	'zoom-in': {
		keywords: ['zoom-in', 'zoomin', 'icon', 'magnify', 'magnifying glass'],
		componentName: 'ZoomInIcon',
		package: '@atlaskit/icon/core/zoom-in',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for zooming in of an object or view.',
		team: 'Design System Team',
		status: 'published',
	},
	'zoom-out': {
		keywords: ['zoom-out', 'zoomout', 'icon', 'minify', 'magnifying glass'],
		componentName: 'ZoomOutIcon',
		package: '@atlaskit/icon/core/zoom-out',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for zooming out of an object or view.',
		team: 'Design System Team',
		status: 'published',
	},
};

export default metadata;
